[
  {
    "id": "qua-001-aida-anthracite-30x60",
    "title": "Aida Anthracite",
    "collection": "Aida",
    "category": "Mutfak Karoları",
    "sku": "aida-anthracite-30x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRAB10X0XPABW00-1.jpg"
    ],
    "description": "Aida Anthracite — Mutfak Karoları. 30X60 ebatında ahşap görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Ahşap",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Ahşap görünümlü porselen kaplama",
      "30X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X60 cm",
      "Ahşap",
      "Mutfak Karoları",
      "Aida"
    ]
  },
  {
    "id": "qua-002-aida-new-white-60x60",
    "title": "Aida New White",
    "collection": "Aida",
    "category": "Mutfak Karoları",
    "sku": "aida-new-white-60x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRAB10X0XPABW00-1.jpg"
    ],
    "description": "Aida New White — Mutfak Karoları. 60X60 ebatında ahşap görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Ahşap",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Ahşap görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Ahşap",
      "Mutfak Karoları",
      "Aida"
    ]
  },
  {
    "id": "qua-003-aida-white-60x60",
    "title": "Aida White",
    "collection": "Aida",
    "category": "Mutfak Karoları",
    "sku": "aida-white-60x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRAB10X0XPABW00-1.jpg"
    ],
    "description": "Aida White — Mutfak Karoları. 60X60 ebatında ahşap görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Ahşap",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Ahşap görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Ahşap",
      "Mutfak Karoları",
      "Aida"
    ]
  },
  {
    "id": "qua-004-aida-white-30x60",
    "title": "Aida White",
    "collection": "Aida",
    "category": "Mutfak Karoları",
    "sku": "aida-white-30x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRAB10X0XPABW00-1.jpg"
    ],
    "description": "Aida White — Mutfak Karoları. 30X60 ebatında ahşap görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Ahşap",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Ahşap görünümlü porselen kaplama",
      "30X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X60 cm",
      "Ahşap",
      "Mutfak Karoları",
      "Aida"
    ]
  },
  {
    "id": "qua-005-alder-chestnut-20x120",
    "title": "Alder Chestnut",
    "collection": "Alder",
    "category": "Mutfak Karoları",
    "sku": "alder-chestnut-20x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P192ZDRV830X0XMABCF0-1.jpg"
    ],
    "description": "Alder Chestnut — Mutfak Karoları. 20X120 ebatında ahşap görünümlü porselen karo.",
    "specs": {
      "Ebat": "20X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Ahşap",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Ahşap görünümlü porselen kaplama",
      "20X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "20X120 cm",
      "Ahşap",
      "Mutfak Karoları",
      "Alder"
    ]
  },
  {
    "id": "qua-006-alder-teak-20x120",
    "title": "Alder Teak",
    "collection": "Alder",
    "category": "Mutfak Karoları",
    "sku": "alder-teak-20x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P192ZDRV830X0XMABCF0-1.jpg"
    ],
    "description": "Alder Teak — Mutfak Karoları. 20X120 ebatında ahşap görünümlü porselen karo.",
    "specs": {
      "Ebat": "20X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Ahşap",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Ahşap görünümlü porselen kaplama",
      "20X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "20X120 cm",
      "Ahşap",
      "Mutfak Karoları",
      "Alder"
    ]
  },
  {
    "id": "qua-007-alder-venge-20x120",
    "title": "Alder Venge",
    "collection": "Alder",
    "category": "Mutfak Karoları",
    "sku": "alder-venge-20x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P192ZDRV830X0XMABCF0-1.jpg"
    ],
    "description": "Alder Venge — Mutfak Karoları. 20X120 ebatında ahşap görünümlü porselen karo.",
    "specs": {
      "Ebat": "20X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Ahşap",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Ahşap görünümlü porselen kaplama",
      "20X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "20X120 cm",
      "Ahşap",
      "Mutfak Karoları",
      "Alder"
    ]
  },
  {
    "id": "qua-008-alpi-60X120",
    "title": "Alpi",
    "collection": "Alpi",
    "category": "Mutfak Karoları",
    "sku": "alpi-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRAI20X0XFABD10-1.jpg"
    ],
    "description": "Alpi — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Alpi"
    ]
  },
  {
    "id": "qua-009-altar-teak-15X60",
    "title": "Altar Teak",
    "collection": "Altar",
    "category": "Mutfak Karoları",
    "sku": "altar-teak-15X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P038XD0AG60V0XMABK60-1.jpg"
    ],
    "description": "Altar Teak — Mutfak Karoları. 15X60 ebatında ahşap görünümlü porselen karo.",
    "specs": {
      "Ebat": "15X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Ahşap",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Ahşap görünümlü porselen kaplama",
      "15X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "15X60 cm",
      "Ahşap",
      "Mutfak Karoları",
      "Altar"
    ]
  },
  {
    "id": "qua-010-amazonica-bienco-15X60",
    "title": "Amazonica Bienco",
    "collection": "Amazonica Bienco",
    "category": "Mutfak Karoları",
    "sku": "amazonica-bienco-15X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P038XD0AG90V0XMABB40-1.jpg"
    ],
    "description": "Amazonica Bienco — Mutfak Karoları. 15X60 ebatında ahşap görünümlü porselen karo.",
    "specs": {
      "Ebat": "15X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Ahşap",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Ahşap görünümlü porselen kaplama",
      "15X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "15X60 cm",
      "Ahşap",
      "Mutfak Karoları",
      "Amazonica Bienco"
    ]
  },
  {
    "id": "qua-011-amazonica-crema-15X60",
    "title": "Amazonica Crema",
    "collection": "Amazonica",
    "category": "Mutfak Karoları",
    "sku": "amazonica-crema-15X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P038XD0AG90V0XMABB40-1.jpg"
    ],
    "description": "Amazonica Crema — Mutfak Karoları. 15X60 ebatında ahşap görünümlü porselen karo.",
    "specs": {
      "Ebat": "15X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Ahşap",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Ahşap görünümlü porselen kaplama",
      "15X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "15X60 cm",
      "Ahşap",
      "Mutfak Karoları",
      "Amazonica"
    ]
  },
  {
    "id": "qua-012-amazonica-grigio-15X60",
    "title": "Amazonica Grigio",
    "collection": "Amazonica",
    "category": "Mutfak Karoları",
    "sku": "amazonica-grigio-15X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P038XD0AG90V0XMABB40-1.jpg"
    ],
    "description": "Amazonica Grigio — Mutfak Karoları. 15X60 ebatında ahşap görünümlü porselen karo.",
    "specs": {
      "Ebat": "15X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Ahşap",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Ahşap görünümlü porselen kaplama",
      "15X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "15X60 cm",
      "Ahşap",
      "Mutfak Karoları",
      "Amazonica"
    ]
  },
  {
    "id": "qua-013-amazonica-natural-15X60",
    "title": "Amazonica Natural",
    "collection": "Amazonica",
    "category": "Mutfak Karoları",
    "sku": "amazonica-natural-15X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P038XD0AG90V0XMABB40-1.jpg"
    ],
    "description": "Amazonica Natural — Mutfak Karoları. 15X60 ebatında ahşap görünümlü porselen karo.",
    "specs": {
      "Ebat": "15X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Ahşap",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Ahşap görünümlü porselen kaplama",
      "15X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "15X60 cm",
      "Ahşap",
      "Mutfak Karoları",
      "Amazonica"
    ]
  },
  {
    "id": "qua-014-apollo-30X90",
    "title": "Apollo",
    "collection": "Apollo",
    "category": "Mutfak Karoları",
    "sku": "apollo-30X90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/W188XDRAH5040XMABB50-1.jpg"
    ],
    "description": "Apollo — Mutfak Karoları. 30X90 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "30X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X90 cm",
      "Beton",
      "Mutfak Karoları",
      "Apollo"
    ]
  },
  {
    "id": "qua-015-apollo-dekofon-30X90",
    "title": "Apollo Dekofon",
    "collection": "Apollo Dekofon",
    "category": "Mutfak Karoları",
    "sku": "apollo-dekofon-30X90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/W188XDRAH5040XMABB50-1.jpg"
    ],
    "description": "Apollo Dekofon — Mutfak Karoları. 30X90 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X90 cm",
      "Yüzey": "3D Yüzey",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "30X90 cm ebat",
      "3D Yüzey yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X90 cm",
      "Beton",
      "Mutfak Karoları",
      "3D Yüzey",
      "Apollo Dekofon"
    ]
  },
  {
    "id": "qua-016-aquiver-60X120",
    "title": "Aquiver",
    "collection": "Aquiver",
    "category": "Mutfak Karoları",
    "sku": "aquiver-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRAH60X0XFABD10-1.jpg"
    ],
    "description": "Aquiver — Mutfak Karoları. 60X120 ebatında mermer görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Mermer",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Mermer görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Mermer",
      "Mutfak Karoları",
      "Aquiver"
    ]
  },
  {
    "id": "qua-017-argon-antico-20x120",
    "title": "Argon Antico",
    "collection": "Argon",
    "category": "Mutfak Karoları",
    "sku": "argon-antico-20x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P192ZDRAG20X0XMABBR0-1.jpg"
    ],
    "description": "Argon Antico — Mutfak Karoları. 20X120 ebatında ahşap görünümlü porselen karo.",
    "specs": {
      "Ebat": "20X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Ahşap",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Ahşap görünümlü porselen kaplama",
      "20X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "20X120 cm",
      "Ahşap",
      "Mutfak Karoları",
      "Argon"
    ]
  },
  {
    "id": "qua-018-aria-antracite-60X120",
    "title": "Aria Antracite",
    "collection": "Aria Antracite",
    "category": "Mutfak Karoları",
    "sku": "aria-antracite-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015ZDRAB60X0XFABG10-1.jpg"
    ],
    "description": "Aria Antracite — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Aria Antracite"
    ]
  },
  {
    "id": "qua-019-aria-grigio-60x60",
    "title": "Aria Grigio",
    "collection": "Aria",
    "category": "Mutfak Karoları",
    "sku": "aria-grigio-60x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015ZDRAB60X0XFABG10-1.jpg"
    ],
    "description": "Aria Grigio — Mutfak Karoları. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Aria"
    ]
  },
  {
    "id": "qua-020-aria-grigio-60X120",
    "title": "Aria Grigio",
    "collection": "Aria",
    "category": "Mutfak Karoları",
    "sku": "aria-grigio-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015ZDRAB60X0XFABG10-1.jpg"
    ],
    "description": "Aria Grigio — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Aria"
    ]
  },
  {
    "id": "qua-021-aria-stone-fumo-60X120",
    "title": "Aria Stone Fumo",
    "collection": "Aria Stone",
    "category": "Mutfak Karoları",
    "sku": "aria-stone-fumo-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015ZDRAB60X0XFABG10-1.jpg"
    ],
    "description": "Aria Stone Fumo — Mutfak Karoları. 60X120 ebatında ahşap görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Ahşap",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Ahşap görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Ahşap",
      "Mutfak Karoları",
      "Aria Stone"
    ]
  },
  {
    "id": "qua-022-ark-anthracite-30x60",
    "title": "Ark Anthracite",
    "collection": "Ark",
    "category": "Banyo Karoları",
    "sku": "ark-anthracite-30x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRA840V0XMABSL0-1.jpg"
    ],
    "description": "Ark Anthracite — Mutfak Karoları. 30X60 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "30X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X60 cm",
      "Beton",
      "Mutfak Karoları",
      "Ark"
    ]
  },
  {
    "id": "qua-023-ark-anthracite-60X60",
    "title": "Ark Anthracite",
    "collection": "Ark",
    "category": "Banyo Karoları",
    "sku": "ark-anthracite-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRA840V0XMABSL0-1.jpg"
    ],
    "description": "Ark Anthracite — Tüm Karolar. 60X60 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Beton",
      "Tüm Karolar",
      "Ark",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-024-ark-anthracite-60X120",
    "title": "Ark Anthracite",
    "collection": "Ark",
    "category": "Banyo Karoları",
    "sku": "ark-anthracite-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRA840V0XMABSL0-1.jpg"
    ],
    "description": "Ark Anthracite — Tüm Karolar. 60X120 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Beton",
      "Tüm Karolar",
      "Ark",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-025-ark-anthracite-80x80",
    "title": "Ark Anthracite",
    "collection": "Ark",
    "category": "Banyo Karoları",
    "sku": "ark-anthracite-80x80",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRA840V0XMABSL0-1.jpg"
    ],
    "description": "Ark Anthracite — Tüm Karolar. 80X80 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "80X80 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "80X80 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "80X80 cm",
      "Beton",
      "Tüm Karolar",
      "Ark",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-026-ark-anthracite-100x100",
    "title": "Ark Anthracite",
    "collection": "Ark",
    "category": "Banyo Karoları",
    "sku": "ark-anthracite-100x100",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRA840V0XMABSL0-1.jpg"
    ],
    "description": "Ark Anthracite — Mutfak Karoları. 100X100 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "100X100 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "100X100 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "100X100 cm",
      "Beton",
      "Mutfak Karoları",
      "Ark"
    ]
  },
  {
    "id": "qua-027-ark-anthracite-30X90",
    "title": "Ark Anthracite",
    "collection": "Ark",
    "category": "Banyo Karoları",
    "sku": "ark-anthracite-30X90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRA840V0XMABSL0-1.jpg"
    ],
    "description": "Ark Anthracite — Mutfak Karoları. 30X90 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "30X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X90 cm",
      "Beton",
      "Mutfak Karoları",
      "Ark"
    ]
  },
  {
    "id": "qua-028-ark-black-60X60",
    "title": "Ark Black",
    "collection": "Ark",
    "category": "Banyo Karoları",
    "sku": "ark-black-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRA840V0XMABSL0-1.jpg"
    ],
    "description": "Ark Black — Tüm Karolar. 60X60 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Beton",
      "Tüm Karolar",
      "Ark",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-029-ark-black-60X120",
    "title": "Ark Black",
    "collection": "Ark",
    "category": "Banyo Karoları",
    "sku": "ark-black-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRA840V0XMABSL0-1.jpg"
    ],
    "description": "Ark Black — Tüm Karolar. 60X120 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Beton",
      "Tüm Karolar",
      "Ark",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-030-ark-black-80x80",
    "title": "Ark Black",
    "collection": "Ark",
    "category": "Banyo Karoları",
    "sku": "ark-black-80x80",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRA840V0XMABSL0-1.jpg"
    ],
    "description": "Ark Black — Tüm Karolar. 80X80 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "80X80 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "80X80 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "80X80 cm",
      "Beton",
      "Tüm Karolar",
      "Ark",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-031-ark-black-30X90",
    "title": "Ark Black",
    "collection": "Ark",
    "category": "Banyo Karoları",
    "sku": "ark-black-30X90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRA840V0XMABSL0-1.jpg"
    ],
    "description": "Ark Black — Mutfak Karoları. 30X90 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "30X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X90 cm",
      "Beton",
      "Mutfak Karoları",
      "Ark"
    ]
  },
  {
    "id": "qua-032-ark-concreto-60X60",
    "title": "Ark Concreto",
    "collection": "Ark",
    "category": "Banyo Karoları",
    "sku": "ark-concreto-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRA840V0XMABSL0-1.jpg"
    ],
    "description": "Ark Concreto — Mutfak Karoları. 60X60 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Beton",
      "Mutfak Karoları",
      "Ark"
    ]
  },
  {
    "id": "qua-033-ark-ivory-60X60",
    "title": "Ark Ivory",
    "collection": "Ark",
    "category": "Banyo Karoları",
    "sku": "ark-ivory-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRA840V0XMABSL0-1.jpg"
    ],
    "description": "Ark Ivory — Tüm Karolar. 60X60 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Beton",
      "Tüm Karolar",
      "Ark",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-034-ark-ivory-60X120",
    "title": "Ark Ivory",
    "collection": "Ark",
    "category": "Banyo Karoları",
    "sku": "ark-ivory-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRA840V0XMABSL0-1.jpg"
    ],
    "description": "Ark Ivory — Tüm Karolar. 60X120 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Beton",
      "Tüm Karolar",
      "Ark",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-035-ark-ivory-60x90",
    "title": "Ark Ivory",
    "collection": "Ark",
    "category": "Banyo Karoları",
    "sku": "ark-ivory-60x90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRA840V0XMABSL0-1.jpg"
    ],
    "description": "Ark Ivory — Tüm Karolar. 60X90 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X90 cm",
      "Beton",
      "Tüm Karolar",
      "Ark",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-036-ark-ivory-120x120",
    "title": "Ark Ivory",
    "collection": "Ark",
    "category": "Banyo Karoları",
    "sku": "ark-ivory-120x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRA840V0XMABSL0-1.jpg"
    ],
    "description": "Ark Ivory — Mutfak Karoları. 120X120 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "120X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "120X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "120X120 cm",
      "Beton",
      "Mutfak Karoları",
      "Ark"
    ]
  },
  {
    "id": "qua-037-ark-ivory-80x80",
    "title": "Ark Ivory",
    "collection": "Ark",
    "category": "Banyo Karoları",
    "sku": "ark-ivory-80x80",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRA840V0XMABSL0-1.jpg"
    ],
    "description": "Ark Ivory — Tüm Karolar. 80X80 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "80X80 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "80X80 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "80X80 cm",
      "Beton",
      "Tüm Karolar",
      "Ark",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-038-ark-ivory-100x100",
    "title": "Ark Ivory",
    "collection": "Ark",
    "category": "Banyo Karoları",
    "sku": "ark-ivory-100x100",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRA840V0XMABSL0-1.jpg"
    ],
    "description": "Ark Ivory — Mutfak Karoları. 100X100 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "100X100 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "100X100 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "100X100 cm",
      "Beton",
      "Mutfak Karoları",
      "Ark"
    ]
  },
  {
    "id": "qua-039-ank-ivory-30x60",
    "title": "Ark Ivory",
    "collection": "Ark",
    "category": "Mutfak Karoları",
    "sku": "ank-ivory-30x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRA840V0XMABSL0-1.jpg"
    ],
    "description": "Ark Ivory — Mutfak Karoları. 30X60 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "30X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X60 cm",
      "Beton",
      "Mutfak Karoları",
      "Ark"
    ]
  },
  {
    "id": "qua-040-ark-ivory-30x60",
    "title": "Ark Ivory",
    "collection": "Ark",
    "category": "Banyo Karoları",
    "sku": "ark-ivory-30x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRA840V0XMABSL0-1.jpg"
    ],
    "description": "Ark Ivory — Mutfak Karoları. 30X60 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "30X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X60 cm",
      "Beton",
      "Mutfak Karoları",
      "Ark"
    ]
  },
  {
    "id": "qua-041-ark-ivory-30X90",
    "title": "Ark Ivory",
    "collection": "Ark",
    "category": "Banyo Karoları",
    "sku": "ark-ivory-30X90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRA840V0XMABSL0-1.jpg"
    ],
    "description": "Ark Ivory — Mutfak Karoları. 30X90 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "30X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X90 cm",
      "Beton",
      "Mutfak Karoları",
      "Ark"
    ]
  },
  {
    "id": "qua-042-ark-silver-60X60",
    "title": "Ark Silver",
    "collection": "Ark",
    "category": "Banyo Karoları",
    "sku": "ark-silver-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRA840V0XMABSL0-1.jpg"
    ],
    "description": "Ark Silver — Mutfak Karoları. 60X60 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Beton",
      "Mutfak Karoları",
      "Ark"
    ]
  },
  {
    "id": "qua-043-ark-silver-60X120",
    "title": "Ark Silver",
    "collection": "Ark",
    "category": "Banyo Karoları",
    "sku": "ark-silver-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRA840V0XMABSL0-1.jpg"
    ],
    "description": "Ark Silver — Tüm Karolar. 60X120 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Beton",
      "Tüm Karolar",
      "Ark",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-044-ark-silver-60x90",
    "title": "Ark Silver",
    "collection": "Ark",
    "category": "Banyo Karoları",
    "sku": "ark-silver-60x90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRA840V0XMABSL0-1.jpg"
    ],
    "description": "Ark Silver — Tüm Karolar. 60X90 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X90 cm",
      "Beton",
      "Tüm Karolar",
      "Ark",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-045-ark-silver-120x120",
    "title": "Ark Silver",
    "collection": "Ark",
    "category": "Banyo Karoları",
    "sku": "ark-silver-120x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRA840V0XMABSL0-1.jpg"
    ],
    "description": "Ark Silver — Mutfak Karoları. 120X120 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "120X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "120X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "120X120 cm",
      "Beton",
      "Mutfak Karoları",
      "Ark"
    ]
  },
  {
    "id": "qua-046-ark-silver-80x80",
    "title": "Ark Silver",
    "collection": "Ark",
    "category": "Banyo Karoları",
    "sku": "ark-silver-80x80",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRA840V0XMABSL0-1.jpg"
    ],
    "description": "Ark Silver — Tüm Karolar. 80X80 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "80X80 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "80X80 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "80X80 cm",
      "Beton",
      "Tüm Karolar",
      "Ark",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-047-ark-silver-100x100",
    "title": "Ark Silver",
    "collection": "Ark",
    "category": "Banyo Karoları",
    "sku": "ark-silver-100x100",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRA840V0XMABSL0-1.jpg"
    ],
    "description": "Ark Silver — Mutfak Karoları. 100X100 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "100X100 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "100X100 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "100X100 cm",
      "Beton",
      "Mutfak Karoları",
      "Ark"
    ]
  },
  {
    "id": "qua-048-ark-silver-30x60",
    "title": "Ark Silver",
    "collection": "Ark",
    "category": "Banyo Karoları",
    "sku": "ark-silver-30x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRA840V0XMABSL0-1.jpg"
    ],
    "description": "Ark Silver — Mutfak Karoları. 30X60 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "30X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X60 cm",
      "Beton",
      "Mutfak Karoları",
      "Ark"
    ]
  },
  {
    "id": "qua-049-ark-silver-30X90",
    "title": "Ark Silver",
    "collection": "Ark",
    "category": "Banyo Karoları",
    "sku": "ark-silver-30X90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRA840V0XMABSL0-1.jpg"
    ],
    "description": "Ark Silver — Mutfak Karoları. 30X90 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "30X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X90 cm",
      "Beton",
      "Mutfak Karoları",
      "Ark"
    ]
  },
  {
    "id": "qua-050-ark-white-60X60",
    "title": "Ark White",
    "collection": "Ark",
    "category": "Banyo Karoları",
    "sku": "ark-white-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRA840V0XMABSL0-1.jpg"
    ],
    "description": "Ark White — Mutfak Karoları. 60X60 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Beton",
      "Mutfak Karoları",
      "Ark"
    ]
  },
  {
    "id": "qua-051-ark-white-30x60",
    "title": "Ark White",
    "collection": "Ark",
    "category": "Banyo Karoları",
    "sku": "ark-white-30x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRA840V0XMABSL0-1.jpg"
    ],
    "description": "Ark White — Mutfak Karoları. 30X60 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "30X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X60 cm",
      "Beton",
      "Mutfak Karoları",
      "Ark"
    ]
  },
  {
    "id": "qua-052-ark-white-60X120",
    "title": "Ark White",
    "collection": "Ark",
    "category": "Banyo Karoları",
    "sku": "ark-white-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRA840V0XMABSL0-1.jpg"
    ],
    "description": "Ark White — Tüm Karolar. 60X120 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Beton",
      "Tüm Karolar",
      "Ark",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-053-ark-white-100x100",
    "title": "Ark White",
    "collection": "Ark",
    "category": "Banyo Karoları",
    "sku": "ark-white-100x100",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRA840V0XMABSL0-1.jpg"
    ],
    "description": "Ark White — Mutfak Karoları. 100X100 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "100X100 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "100X100 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "100X100 cm",
      "Beton",
      "Mutfak Karoları",
      "Ark"
    ]
  },
  {
    "id": "qua-054-ark-white-30X90",
    "title": "Ark White",
    "collection": "Ark",
    "category": "Banyo Karoları",
    "sku": "ark-white-30X90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRA840V0XMABSL0-1.jpg"
    ],
    "description": "Ark White — Mutfak Karoları. 30X90 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "30X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X90 cm",
      "Beton",
      "Mutfak Karoları",
      "Ark"
    ]
  },
  {
    "id": "qua-055-armani-60X120",
    "title": "Armani",
    "collection": "Armani",
    "category": "Mutfak Karoları",
    "sku": "armani-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRAG80X0XFABD10-1.jpg"
    ],
    "description": "Armani — Mutfak Karoları. 60X120 ebatında mermer görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Mermer",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Mermer görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Mermer",
      "Mutfak Karoları",
      "Armani"
    ]
  },
  {
    "id": "qua-056-aurora-60X120",
    "title": "Aurora",
    "collection": "Aurora",
    "category": "Mutfak Karoları",
    "sku": "aurora-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRA470X0XFABD10-1.jpg"
    ],
    "description": "Aurora — Mutfak Karoları. 60X120 ebatında mermer görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Mermer",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Mermer görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Mermer",
      "Mutfak Karoları",
      "Aurora"
    ]
  },
  {
    "id": "qua-057-beige-travertine-60X60",
    "title": "Beige Travertine",
    "collection": "Beige Travertine",
    "category": "Banyo Karoları",
    "sku": "beige-travertine-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRSD80V0BMABSL0-1.jpg"
    ],
    "description": "Beige Travertine — Tüm Karolar. 60X60 ebatında travertin görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Travertin",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Travertin görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Travertin",
      "Tüm Karolar",
      "Beige Travertine",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-058-benelux-black-60X60",
    "title": "Benelux Black",
    "collection": "Benelux",
    "category": "Banyo Karoları",
    "sku": "benelux-black-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRB480V0BMABGR0-1.jpg"
    ],
    "description": "Benelux Black — Tüm Karolar. 60X60 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Beton",
      "Tüm Karolar",
      "Benelux",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-059-benelux-black-80x80",
    "title": "Benelux Black",
    "collection": "Benelux",
    "category": "Banyo Karoları",
    "sku": "benelux-black-80x80",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRB480V0BMABGR0-1.jpg"
    ],
    "description": "Benelux Black — Tüm Karolar. 80X80 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "80X80 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "80X80 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "80X80 cm",
      "Beton",
      "Tüm Karolar",
      "Benelux",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-060-benelux-grey-60X60",
    "title": "Benelux Grey",
    "collection": "Benelux",
    "category": "Banyo Karoları",
    "sku": "benelux-grey-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRB480V0BMABGR0-1.jpg"
    ],
    "description": "Benelux Grey — Tüm Karolar. 60X60 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Beton",
      "Tüm Karolar",
      "Benelux",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-061-benelux-grey-80x80",
    "title": "Benelux Grey",
    "collection": "Benelux",
    "category": "Banyo Karoları",
    "sku": "benelux-grey-80x80",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRB480V0BMABGR0-1.jpg"
    ],
    "description": "Benelux Grey — Tüm Karolar. 80X80 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "80X80 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "80X80 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "80X80 cm",
      "Beton",
      "Tüm Karolar",
      "Benelux",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-062-bianco-dolomiti-60X120",
    "title": "Bianco Dolomiti",
    "collection": "Bianco Dolomiti",
    "category": "Banyo Karoları",
    "sku": "bianco-dolomiti-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRB620X0XFABD10-1.jpg"
    ],
    "description": "Bianco Dolomiti — Mutfak Karoları. 60X120 ebatında mermer görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Mermer",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Mermer görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Mermer",
      "Mutfak Karoları",
      "Bianco Dolomiti"
    ]
  },
  {
    "id": "qua-063-bianco-river-30x60",
    "title": "Bianco River",
    "collection": "Bianco River",
    "category": "Mutfak Karoları",
    "sku": "bianco-river-30x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCB580X0XFABW50-1.jpg"
    ],
    "description": "Bianco River — Mutfak Karoları. 30X60 ebatında mermer görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Mermer",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Mermer görünümlü porselen kaplama",
      "30X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X60 cm",
      "Mermer",
      "Mutfak Karoları",
      "Bianco River"
    ]
  },
  {
    "id": "qua-064-bianco-river-60X60",
    "title": "Bianco River",
    "collection": "Bianco River",
    "category": "Mutfak Karoları",
    "sku": "bianco-river-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCB580X0XFABW50-1.jpg"
    ],
    "description": "Bianco River — Mutfak Karoları. 60X60 ebatında mermer görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Mermer",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Mermer görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Mermer",
      "Mutfak Karoları",
      "Bianco River"
    ]
  },
  {
    "id": "qua-065-bianco-river-60X120",
    "title": "Bianco River",
    "collection": "Bianco River",
    "category": "Mutfak Karoları",
    "sku": "bianco-river-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCB580X0XFABW50-1.jpg"
    ],
    "description": "Bianco River — Mutfak Karoları. 60X120 ebatında mermer görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Mermer",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Mermer görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Mermer",
      "Mutfak Karoları",
      "Bianco River"
    ]
  },
  {
    "id": "qua-066-bianco-river-40X120",
    "title": "Bianco River",
    "collection": "Bianco River",
    "category": "Mutfak Karoları",
    "sku": "bianco-river-40X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCB580X0XFABW50-1.jpg"
    ],
    "description": "Bianco River — Mutfak Karoları. 40X120 ebatında mermer görünümlü porselen karo.",
    "specs": {
      "Ebat": "40X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Mermer",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Mermer görünümlü porselen kaplama",
      "40X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "40X120 cm",
      "Mermer",
      "Mutfak Karoları",
      "Bianco River"
    ]
  },
  {
    "id": "qua-067-bianco-river-dekofon-40X120",
    "title": "Bianco River Dekofon",
    "collection": "Bianco River Dekofon",
    "category": "Mutfak Karoları",
    "sku": "bianco-river-dekofon-40X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCB580X0XFABW50-1.jpg"
    ],
    "description": "Bianco River Dekofon — Mutfak Karoları. 40X120 ebatında mermer görünümlü porselen karo.",
    "specs": {
      "Ebat": "40X120 cm",
      "Yüzey": "3D Yüzey",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Mermer",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Mermer görünümlü porselen kaplama",
      "40X120 cm ebat",
      "3D Yüzey yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "40X120 cm",
      "Mermer",
      "Mutfak Karoları",
      "3D Yüzey",
      "Bianco River Dekofon"
    ]
  },
  {
    "id": "qua-068-bref-3d-60x120",
    "title": "Bref 3D",
    "collection": "Bref",
    "category": "Banyo Karoları",
    "sku": "bref-3d-60x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRBC5SX0XMABGR0-1.jpg"
    ],
    "description": "Bref 3D — Mutfak Karoları. 60X120 ebatında mermer görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "3D Yüzey",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Mermer",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Mermer görünümlü porselen kaplama",
      "60X120 cm ebat",
      "3D Yüzey yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Mermer",
      "Mutfak Karoları",
      "3D Yüzey",
      "Bref"
    ]
  },
  {
    "id": "qua-069-cafe-travertino-60X60",
    "title": "Cafe Travertino",
    "collection": "Cafe Travertino",
    "category": "Mutfak Karoları",
    "sku": "cafe-travertino-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCT280X0XMABD10-1.jpg"
    ],
    "description": "Cafe Travertino — Mutfak Karoları. 60X60 ebatında travertin görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Travertin",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Travertin görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Travertin",
      "Mutfak Karoları",
      "Cafe Travertino"
    ]
  },
  {
    "id": "qua-070-cafe-travertino-60X120",
    "title": "Cafe Travertino",
    "collection": "Cafe Travertino",
    "category": "Mutfak Karoları",
    "sku": "cafe-travertino-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCT280X0XMABD10-1.jpg"
    ],
    "description": "Cafe Travertino — Mutfak Karoları. 60X120 ebatında travertin görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Travertin",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Travertin görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Travertin",
      "Mutfak Karoları",
      "Cafe Travertino"
    ]
  },
  {
    "id": "qua-071-calacatta-60X120",
    "title": "Calacatta",
    "collection": "Calacatta",
    "category": "Banyo Karoları",
    "sku": "calacatta-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015ZDRC630X0XFABW50-1.jpg"
    ],
    "description": "Calacatta — Mutfak Karoları. 60X120 ebatında mermer görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Mermer",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Mermer görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Mermer",
      "Mutfak Karoları",
      "Calacatta"
    ]
  },
  {
    "id": "qua-072-calacatta-goldie-60X120",
    "title": "Calacatta Goldie",
    "collection": "Calacatta",
    "category": "Mutfak Karoları",
    "sku": "calacatta-goldie-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRZ710X0XFABD10-1.jpg"
    ],
    "description": "Calacatta Goldie — Mutfak Karoları. 60X120 ebatında mermer görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Mermer",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Mermer görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Mermer",
      "Mutfak Karoları",
      "Calacatta"
    ]
  },
  {
    "id": "qua-073-caldera-latte-60X60",
    "title": "Caldera Latte",
    "collection": "Caldera",
    "category": "Mutfak Karoları",
    "sku": "caldera-latte-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015ZDRCE40X0XMABLT0-1.jpg"
    ],
    "description": "Caldera Latte — Mutfak Karoları. 60X60 ebatında ahşap görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Ahşap",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Ahşap görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Ahşap",
      "Mutfak Karoları",
      "Caldera"
    ]
  },
  {
    "id": "qua-074-caldera-latte-60X120",
    "title": "Caldera Latte",
    "collection": "Caldera",
    "category": "Mutfak Karoları",
    "sku": "caldera-latte-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015ZDRCE40X0XMABLT0-1.jpg"
    ],
    "description": "Caldera Latte — Mutfak Karoları. 60X120 ebatında ahşap görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Ahşap",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Ahşap görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Ahşap",
      "Mutfak Karoları",
      "Caldera"
    ]
  },
  {
    "id": "qua-075-canyon-grigio-30x60",
    "title": "Canyon Grigio",
    "collection": "Canyon",
    "category": "Mutfak Karoları",
    "sku": "canyon-grigio-30x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCC620X0XFABG50-1.jpg"
    ],
    "description": "Canyon Grigio — Mutfak Karoları. 30X60 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "30X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X60 cm",
      "Beton",
      "Mutfak Karoları",
      "Canyon"
    ]
  },
  {
    "id": "qua-076-canyon-grigio-60X60",
    "title": "Canyon Grigio",
    "collection": "Canyon",
    "category": "Mutfak Karoları",
    "sku": "canyon-grigio-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCC620X0XFABG50-1.jpg"
    ],
    "description": "Canyon Grigio — Mutfak Karoları. 60X60 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Beton",
      "Mutfak Karoları",
      "Canyon"
    ]
  },
  {
    "id": "qua-077-canyon-grigio-60X120",
    "title": "Canyon Grigio",
    "collection": "Canyon",
    "category": "Mutfak Karoları",
    "sku": "canyon-grigio-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCC620X0XFABG50-1.jpg"
    ],
    "description": "Canyon Grigio — Mutfak Karoları. 60X120 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Beton",
      "Mutfak Karoları",
      "Canyon"
    ]
  },
  {
    "id": "qua-078-canyon-oro-60X60",
    "title": "Canyon Oro",
    "collection": "Canyon",
    "category": "Mutfak Karoları",
    "sku": "canyon-oro-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCC620X0XFABG50-1.jpg"
    ],
    "description": "Canyon Oro — Mutfak Karoları. 60X60 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Beton",
      "Mutfak Karoları",
      "Canyon"
    ]
  },
  {
    "id": "qua-079-canyon-oro-60X120",
    "title": "Canyon Oro",
    "collection": "Canyon",
    "category": "Mutfak Karoları",
    "sku": "canyon-oro-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCC620X0XFABG50-1.jpg"
    ],
    "description": "Canyon Oro — Mutfak Karoları. 60X120 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Beton",
      "Mutfak Karoları",
      "Canyon"
    ]
  },
  {
    "id": "qua-080-capri-maple-60X120",
    "title": "Capri Maple",
    "collection": "Capri",
    "category": "Mutfak Karoları",
    "sku": "capri-maple-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRPD90X0XMABB40-1.jpg"
    ],
    "description": "Capri Maple — Mutfak Karoları. 60X120 ebatında ahşap görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Ahşap",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Ahşap görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Ahşap",
      "Mutfak Karoları",
      "Capri"
    ]
  },
  {
    "id": "qua-081-capri-oak-60X120",
    "title": "Capri Oak",
    "collection": "Capri",
    "category": "Mutfak Karoları",
    "sku": "capri-oak-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRPD90X0XMABB40-1.jpg"
    ],
    "description": "Capri Oak — Mutfak Karoları. 60X120 ebatında ahşap görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Ahşap",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Ahşap görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Ahşap",
      "Mutfak Karoları",
      "Capri"
    ]
  },
  {
    "id": "qua-082-capri-walnut-60X120",
    "title": "Capri Walnut",
    "collection": "Capri",
    "category": "Mutfak Karoları",
    "sku": "capri-walnut-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRPD90X0XMABB40-1.jpg"
    ],
    "description": "Capri Walnut — Mutfak Karoları. 60X120 ebatında ahşap görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Ahşap",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Ahşap görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Ahşap",
      "Mutfak Karoları",
      "Capri"
    ]
  },
  {
    "id": "qua-083-celina-60X120",
    "title": "Celina",
    "collection": "Celina",
    "category": "Mutfak Karoları",
    "sku": "celina-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRCE50X0XFABD10-1.jpg"
    ],
    "description": "Celina — Mutfak Karoları. 60X120 ebatında mermer görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Mermer",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Mermer görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Mermer",
      "Mutfak Karoları",
      "Celina"
    ]
  },
  {
    "id": "qua-084-ceres-60X60",
    "title": "Ceres",
    "collection": "Ceres",
    "category": "Banyo Karoları",
    "sku": "ceres-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015ZDRC970X0XPABD10-1.jpg"
    ],
    "description": "Ceres — Mutfak Karoları. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Ceres"
    ]
  },
  {
    "id": "qua-085-ceres-40X120",
    "title": "Ceres",
    "collection": "Ceres",
    "category": "Banyo Karoları",
    "sku": "ceres-40X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015ZDRC970X0XPABD10-1.jpg"
    ],
    "description": "Ceres — Mutfak Karoları. 40X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "40X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "40X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "40X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Ceres"
    ]
  },
  {
    "id": "qua-086-ceres-dekofon-40X120",
    "title": "Ceres Dekofon",
    "collection": "Ceres Dekofon",
    "category": "Mutfak Karoları",
    "sku": "ceres-dekofon-40X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015ZDRC970X0XPABD10-1.jpg"
    ],
    "description": "Ceres Dekofon — Mutfak Karoları. 40X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "40X120 cm",
      "Yüzey": "3D Yüzey",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "40X120 cm ebat",
      "3D Yüzey yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "40X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "3D Yüzey",
      "Ceres Dekofon"
    ]
  },
  {
    "id": "qua-087-chalky-dark-60X120",
    "title": "Chalky Dark",
    "collection": "Chalky",
    "category": "Banyo Karoları",
    "sku": "chalky-dark-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRV880X0XGABD00-1.jpg"
    ],
    "description": "Chalky Dark — Mutfak Karoları. 60X120 ebatında mermer görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Mermer",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Mermer görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Mermer",
      "Mutfak Karoları",
      "Chalky"
    ]
  },
  {
    "id": "qua-088-chalky-light-60X120",
    "title": "Chalky Light",
    "collection": "Chalky",
    "category": "Banyo Karoları",
    "sku": "chalky-light-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRV880X0XGABD00-1.jpg"
    ],
    "description": "Chalky Light — Mutfak Karoları. 60X120 ebatında mermer görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Mermer",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Mermer görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Mermer",
      "Mutfak Karoları",
      "Chalky"
    ]
  },
  {
    "id": "qua-089-chelsea-walnut-20x120",
    "title": "Chelsea Walnut",
    "collection": "Chelsea",
    "category": "Mutfak Karoları",
    "sku": "chelsea-walnut-20x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P192ZDRCE80X0XMABW00-1.jpg"
    ],
    "description": "Chelsea Walnut — Mutfak Karoları. 20X120 ebatında ahşap görünümlü porselen karo.",
    "specs": {
      "Ebat": "20X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Ahşap",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Ahşap görünümlü porselen kaplama",
      "20X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "20X120 cm",
      "Ahşap",
      "Mutfak Karoları",
      "Chelsea"
    ]
  },
  {
    "id": "qua-090-chelsea-white-oak-20x120",
    "title": "Chelsea White Oak",
    "collection": "Chelsea White",
    "category": "Mutfak Karoları",
    "sku": "chelsea-white-oak-20x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P192ZDRCE80X0XMABW00-1.jpg"
    ],
    "description": "Chelsea White Oak — Mutfak Karoları. 20X120 ebatında ahşap görünümlü porselen karo.",
    "specs": {
      "Ebat": "20X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Ahşap",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Ahşap görünümlü porselen kaplama",
      "20X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "20X120 cm",
      "Ahşap",
      "Mutfak Karoları",
      "Chelsea White"
    ]
  },
  {
    "id": "qua-091-choice-grey-60X120",
    "title": "Choice Grey",
    "collection": "Choice",
    "category": "Banyo Karoları",
    "sku": "choice-grey-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRCF50X0XGABA50-1.jpg"
    ],
    "description": "Choice Grey — Mutfak Karoları. 60X120 ebatında mermer görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Mermer",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Mermer görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Mermer",
      "Mutfak Karoları",
      "Choice"
    ]
  },
  {
    "id": "qua-092-choice-red-60X120",
    "title": "Choice Red",
    "collection": "Choice",
    "category": "Banyo Karoları",
    "sku": "choice-red-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRCF50X0XGABA50-1.jpg"
    ],
    "description": "Choice Red — Mutfak Karoları. 60X120 ebatında mermer görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Mermer",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Mermer görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Mermer",
      "Mutfak Karoları",
      "Choice"
    ]
  },
  {
    "id": "qua-093-choise-white-60X120",
    "title": "Choise White",
    "collection": "Choise",
    "category": "Banyo Karoları",
    "sku": "choise-white-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRCF50X0XGABA50-1.jpg"
    ],
    "description": "Choise White — Mutfak Karoları. 60X120 ebatında mermer görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Mermer",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Mermer görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Mermer",
      "Mutfak Karoları",
      "Choise"
    ]
  },
  {
    "id": "qua-094-cippolino-grigio-60X120",
    "title": "Cippolino Grigio",
    "collection": "Cippolino",
    "category": "Mutfak Karoları",
    "sku": "cippolino-grigio-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156XDRC510X0XGABG10-1.jpg"
    ],
    "description": "Cippolino Grigio — Mutfak Karoları. 60X120 ebatında mermer görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Mermer",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Mermer görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Mermer",
      "Mutfak Karoları",
      "Cippolino"
    ]
  },
  {
    "id": "qua-095-cippolino-nero-60X120",
    "title": "Cippolino Nero",
    "collection": "Cippolino",
    "category": "Mutfak Karoları",
    "sku": "cippolino-nero-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156XDRC510X0XGABG10-1.jpg"
    ],
    "description": "Cippolino Nero — Mutfak Karoları. 60X120 ebatında mermer görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Mermer",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Mermer görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Mermer",
      "Mutfak Karoları",
      "Cippolino"
    ]
  },
  {
    "id": "qua-096-cippolino-white-60X120",
    "title": "Cippolino White",
    "collection": "Cippolino",
    "category": "Mutfak Karoları",
    "sku": "cippolino-white-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156XDRC510X0XGABG10-1.jpg"
    ],
    "description": "Cippolino White — Mutfak Karoları. 60X120 ebatında mermer görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Mermer",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Mermer görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Mermer",
      "Mutfak Karoları",
      "Cippolino"
    ]
  },
  {
    "id": "qua-097-clam-shell-bone-60X120",
    "title": "Clam Shell Bone",
    "collection": "Clam Shell",
    "category": "Mutfak Karoları",
    "sku": "clam-shell-bone-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDR52V0X0XKABB10-1.jpg"
    ],
    "description": "Clam Shell Bone — Mutfak Karoları. 60X120 ebatında mermer görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Mermer",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Mermer görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Mermer",
      "Mutfak Karoları",
      "Clam Shell"
    ]
  },
  {
    "id": "qua-098-clam-shell-bronze-60X120",
    "title": "Clam Shell Bronze",
    "collection": "Clam Shell",
    "category": "Mutfak Karoları",
    "sku": "clam-shell-bronze-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDR52V0X0XKABB10-1.jpg"
    ],
    "description": "Clam Shell Bronze — Mutfak Karoları. 60X120 ebatında mermer görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Mermer",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Mermer görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Mermer",
      "Mutfak Karoları",
      "Clam Shell"
    ]
  },
  {
    "id": "qua-099-cora-beige-30x60",
    "title": "Cora Beige",
    "collection": "Cora",
    "category": "Mutfak Karoları",
    "sku": "cora-beige-30x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRCE70X0XMABBO0-1.jpg"
    ],
    "description": "Cora Beige — Mutfak Karoları. 30X60 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "30X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X60 cm",
      "Beton",
      "Mutfak Karoları",
      "Cora"
    ]
  },
  {
    "id": "qua-100-cora-brown-30x60",
    "title": "Cora Brown",
    "collection": "Cora",
    "category": "Mutfak Karoları",
    "sku": "cora-brown-30x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRCE70X0XMABBO0-1.jpg"
    ],
    "description": "Cora Brown — Mutfak Karoları. 30X60 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "30X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X60 cm",
      "Beton",
      "Mutfak Karoları",
      "Cora"
    ]
  },
  {
    "id": "qua-101-cora-browni-30X90",
    "title": "Cora Browni",
    "collection": "Cora",
    "category": "Mutfak Karoları",
    "sku": "cora-browni-30X90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRCE70X0XMABBO0-1.jpg"
    ],
    "description": "Cora Browni — Mutfak Karoları. 30X90 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "30X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X90 cm",
      "Beton",
      "Mutfak Karoları",
      "Cora"
    ]
  },
  {
    "id": "qua-102-cora-grey-30X90",
    "title": "Cora Grey",
    "collection": "Cora",
    "category": "Mutfak Karoları",
    "sku": "cora-grey-30X90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRCE70X0XMABBO0-1.jpg"
    ],
    "description": "Cora Grey — Mutfak Karoları. 30X90 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "30X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X90 cm",
      "Beton",
      "Mutfak Karoları",
      "Cora"
    ]
  },
  {
    "id": "qua-103-cordella-3d-60x120",
    "title": "Cordella 3D",
    "collection": "Cordella",
    "category": "Banyo Karoları",
    "sku": "cordella-3d-60x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRCH5SX0XMABG50-1.jpg"
    ],
    "description": "Cordella 3D — Mutfak Karoları. 60X120 ebatında mermer görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "3D Yüzey",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Mermer",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Mermer görünümlü porselen kaplama",
      "60X120 cm ebat",
      "3D Yüzey yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Mermer",
      "Mutfak Karoları",
      "3D Yüzey",
      "Cordella"
    ]
  },
  {
    "id": "qua-104-core-beige-60X60",
    "title": "Core Beige",
    "collection": "Core",
    "category": "Mutfak Karoları",
    "sku": "core-beige-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRCE70X0XMABBO0-1.jpg"
    ],
    "description": "Core Beige — Mutfak Karoları. 60X60 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Beton",
      "Mutfak Karoları",
      "Core"
    ]
  },
  {
    "id": "qua-105-core-ivory-61x61",
    "title": "Core Ivory",
    "collection": "Core",
    "category": "Mutfak Karoları",
    "sku": "core-ivory-61x61",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRCE70X0XMABBO0-1.jpg"
    ],
    "description": "Core Ivory — Mutfak Karoları. 61X61 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "61X61 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "61X61 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "61X61 cm",
      "Beton",
      "Mutfak Karoları",
      "Core"
    ]
  },
  {
    "id": "qua-106-core-silver-61x61",
    "title": "Core Silver",
    "collection": "Core",
    "category": "Mutfak Karoları",
    "sku": "core-silver-61x61",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRCE70X0XMABBO0-1.jpg"
    ],
    "description": "Core Silver — Mutfak Karoları. 61X61 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "61X61 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "61X61 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "61X61 cm",
      "Beton",
      "Mutfak Karoları",
      "Core"
    ]
  },
  {
    "id": "qua-107-crema-travertino-60X60",
    "title": "Crema Travertino",
    "collection": "Crema Travertino",
    "category": "Mutfak Karoları",
    "sku": "crema-travertino-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCT280X0XMABD10-1.jpg"
    ],
    "description": "Crema Travertino — Mutfak Karoları. 60X60 ebatında travertin görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Travertin",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Travertin görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Travertin",
      "Mutfak Karoları",
      "Crema Travertino"
    ]
  },
  {
    "id": "qua-108-crema-travertino-30x60",
    "title": "Crema Travertino",
    "collection": "Crema Travertino",
    "category": "Mutfak Karoları",
    "sku": "crema-travertino-30x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCT280X0XMABD10-1.jpg"
    ],
    "description": "Crema Travertino — Mutfak Karoları. 30X60 ebatında travertin görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Travertin",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Travertin görünümlü porselen kaplama",
      "30X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X60 cm",
      "Travertin",
      "Mutfak Karoları",
      "Crema Travertino"
    ]
  },
  {
    "id": "qua-109-crema-travertino-60X120",
    "title": "Crema Travertino",
    "collection": "Crema Travertino",
    "category": "Mutfak Karoları",
    "sku": "crema-travertino-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCT280X0XMABD10-1.jpg"
    ],
    "description": "Crema Travertino — Mutfak Karoları. 60X120 ebatında travertin görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Travertin",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Travertin görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Travertin",
      "Mutfak Karoları",
      "Crema Travertino"
    ]
  },
  {
    "id": "qua-110-creme-blanc-60X120",
    "title": "Creme Blanc",
    "collection": "Creme Blanc",
    "category": "Banyo Karoları",
    "sku": "creme-blanc-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRCF40X0XFABBN0-1.jpg"
    ],
    "description": "Creme Blanc — Mutfak Karoları. 60X120 ebatında mermer görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Mermer",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Mermer görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Mermer",
      "Mutfak Karoları",
      "Creme Blanc"
    ]
  },
  {
    "id": "qua-111-dakota-beige-60X60",
    "title": "Dakota Beige",
    "collection": "Dakota",
    "category": "İç Mekan Karoları",
    "sku": "dakota-beige-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRD290V0BMABBO0-1.jpg"
    ],
    "description": "Dakota Beige — Tüm Karolar. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Tüm Karolar",
      "Dakota",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-112-dakota-beige-60X120",
    "title": "Dakota Beige",
    "collection": "Dakota",
    "category": "İç Mekan Karoları",
    "sku": "dakota-beige-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRD290V0BMABBO0-1.jpg"
    ],
    "description": "Dakota Beige — Tüm Karolar. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Tüm Karolar",
      "Dakota",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-113-dakota-beige-60x90",
    "title": "Dakota Beige",
    "collection": "Dakota",
    "category": "İç Mekan Karoları",
    "sku": "dakota-beige-60x90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRD290V0BMABBO0-1.jpg"
    ],
    "description": "Dakota Beige — Tüm Karolar. 60X90 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X90 cm",
      "Porselen",
      "Tüm Karolar",
      "Dakota",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-114-dakota-dark-grey-60X60",
    "title": "Dakota Dark Grey",
    "collection": "Dakota Dark",
    "category": "İç Mekan Karoları",
    "sku": "dakota-dark-grey-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRD290V0BMABBO0-1.jpg"
    ],
    "description": "Dakota Dark Grey — Tüm Karolar. 60X60 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Beton",
      "Tüm Karolar",
      "Dakota Dark",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-115-dakota-dark-grey-60x90",
    "title": "Dakota Dark Grey",
    "collection": "Dakota Dark",
    "category": "İç Mekan Karoları",
    "sku": "dakota-dark-grey-60x90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRD290V0BMABBO0-1.jpg"
    ],
    "description": "Dakota Dark Grey — Tüm Karolar. 60X90 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X90 cm",
      "Beton",
      "Tüm Karolar",
      "Dakota Dark",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-116-dakota-dark-grey-80x80",
    "title": "Dakota Dark Grey",
    "collection": "Dakota Dark",
    "category": "İç Mekan Karoları",
    "sku": "dakota-dark-grey-80x80",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRD290V0BMABBO0-1.jpg"
    ],
    "description": "Dakota Dark Grey — Tüm Karolar. 80X80 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "80X80 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "80X80 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "80X80 cm",
      "Beton",
      "Tüm Karolar",
      "Dakota Dark",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-117-dakota-grey-60X60",
    "title": "Dakota Grey",
    "collection": "Dakota",
    "category": "İç Mekan Karoları",
    "sku": "dakota-grey-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRD290V0BMABBO0-1.jpg"
    ],
    "description": "Dakota Grey — Tüm Karolar. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Tüm Karolar",
      "Dakota",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-118-dakota-grey-60x90",
    "title": "Dakota Grey",
    "collection": "Dakota",
    "category": "İç Mekan Karoları",
    "sku": "dakota-grey-60x90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRD290V0BMABBO0-1.jpg"
    ],
    "description": "Dakota Grey — Tüm Karolar. 60X90 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X90 cm",
      "Porselen",
      "Tüm Karolar",
      "Dakota",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-119-diamond-chesnut-20x120",
    "title": "Diamond Chesnut",
    "collection": "Diamond",
    "category": "Mutfak Karoları",
    "sku": "diamond-chesnut-20x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P192ZDRD110X0XMABCU0-1.jpg"
    ],
    "description": "Diamond Chesnut — Mutfak Karoları. 20X120 ebatında ahşap görünümlü porselen karo.",
    "specs": {
      "Ebat": "20X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Ahşap",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Ahşap görünümlü porselen kaplama",
      "20X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "20X120 cm",
      "Ahşap",
      "Mutfak Karoları",
      "Diamond"
    ]
  },
  {
    "id": "qua-120-diamond-honey-20x120",
    "title": "Diamond Honey",
    "collection": "Diamond",
    "category": "Mutfak Karoları",
    "sku": "diamond-honey-20x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P192ZDRD110X0XMABCU0-1.jpg"
    ],
    "description": "Diamond Honey — Mutfak Karoları. 20X120 ebatında ahşap görünümlü porselen karo.",
    "specs": {
      "Ebat": "20X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Ahşap",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Ahşap görünümlü porselen kaplama",
      "20X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "20X120 cm",
      "Ahşap",
      "Mutfak Karoları",
      "Diamond"
    ]
  },
  {
    "id": "qua-121-diamond-maple-20x120",
    "title": "Diamond Maple",
    "collection": "Diamond",
    "category": "Mutfak Karoları",
    "sku": "diamond-maple-20x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P192ZDRD110X0XMABCU0-1.jpg"
    ],
    "description": "Diamond Maple — Mutfak Karoları. 20X120 ebatında ahşap görünümlü porselen karo.",
    "specs": {
      "Ebat": "20X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Ahşap",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Ahşap görünümlü porselen kaplama",
      "20X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "20X120 cm",
      "Ahşap",
      "Mutfak Karoları",
      "Diamond"
    ]
  },
  {
    "id": "qua-122-dreamy-grey-60X120",
    "title": "Dreamy Grey",
    "collection": "Dreamy",
    "category": "Banyo Karoları",
    "sku": "dreamy-grey-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDR42V0X0XKABGR0-1.jpg"
    ],
    "description": "Dreamy Grey — Mutfak Karoları. 60X120 ebatında mermer görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Mermer",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Mermer görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Mermer",
      "Mutfak Karoları",
      "Dreamy"
    ]
  },
  {
    "id": "qua-123-dreamy-sand-60X120",
    "title": "Dreamy Sand",
    "collection": "Dreamy",
    "category": "Banyo Karoları",
    "sku": "dreamy-sand-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDR42V0X0XKABGR0-1.jpg"
    ],
    "description": "Dreamy Sand — Mutfak Karoları. 60X120 ebatında mermer görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Mermer",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Mermer görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Mermer",
      "Mutfak Karoları",
      "Dreamy"
    ]
  },
  {
    "id": "qua-124-eiffel-60X60",
    "title": "Eiffel",
    "collection": "Eiffel",
    "category": "Banyo Karoları",
    "sku": "eiffel-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRE580X0XPABD10-1.jpg"
    ],
    "description": "Eiffel — Mutfak Karoları. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Eiffel"
    ]
  },
  {
    "id": "qua-125-epoch-anthracite-61x61",
    "title": "Epoch Anthracite",
    "collection": "Epoch",
    "category": "Mutfak Karoları",
    "sku": "epoch-anthracite-61x61",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P048ZD0E600X0XGABAT0-1.jpg"
    ],
    "description": "Epoch Anthracite — Mutfak Karoları. 61X61 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "61X61 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "61X61 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "61X61 cm",
      "Beton",
      "Mutfak Karoları",
      "Epoch"
    ]
  },
  {
    "id": "qua-126-epoch-anthracite-60X120",
    "title": "Epoch Anthracite",
    "collection": "Epoch",
    "category": "Mutfak Karoları",
    "sku": "epoch-anthracite-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P048ZD0E600X0XGABAT0-1.jpg"
    ],
    "description": "Epoch Anthracite — Mutfak Karoları. 60X120 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Beton",
      "Mutfak Karoları",
      "Epoch"
    ]
  },
  {
    "id": "qua-127-epoch-cotto-60X120",
    "title": "Epoch Cotto",
    "collection": "Epoch Cotto",
    "category": "Mutfak Karoları",
    "sku": "epoch-cotto-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P048ZD0E600X0XGABAT0-1.jpg"
    ],
    "description": "Epoch Cotto — Mutfak Karoları. 60X120 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Beton",
      "Mutfak Karoları",
      "Epoch Cotto"
    ]
  },
  {
    "id": "qua-128-epoch-silver-61x61",
    "title": "Epoch Silver",
    "collection": "Epoch",
    "category": "Mutfak Karoları",
    "sku": "epoch-silver-61x61",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P048ZD0E600X0XGABAT0-1.jpg"
    ],
    "description": "Epoch Silver — Mutfak Karoları. 61X61 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "61X61 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "61X61 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "61X61 cm",
      "Beton",
      "Mutfak Karoları",
      "Epoch"
    ]
  },
  {
    "id": "qua-129-epoch-silver-60X120",
    "title": "Epoch Silver",
    "collection": "Epoch",
    "category": "Mutfak Karoları",
    "sku": "epoch-silver-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P048ZD0E600X0XGABAT0-1.jpg"
    ],
    "description": "Epoch Silver — Mutfak Karoları. 60X120 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Beton",
      "Mutfak Karoları",
      "Epoch"
    ]
  },
  {
    "id": "qua-130-faun-elm-30x120",
    "title": "Faun Elm",
    "collection": "Faun Elm",
    "category": "Mutfak Karoları",
    "sku": "faun-elm-30x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P171BDRN380V0BMAB000-1.jpg"
    ],
    "description": "Faun Elm — Tüm Karolar. 30X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X120 cm",
      "Porselen",
      "Tüm Karolar",
      "Faun Elm",
      "Mutfak Karoları"
    ]
  },
  {
    "id": "qua-131-faun-maple-30x120",
    "title": "Faun Maple",
    "collection": "Faun",
    "category": "Mutfak Karoları",
    "sku": "faun-maple-30x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P171BDRN380V0BMAB000-1.jpg"
    ],
    "description": "Faun Maple — Tüm Karolar. 30X120 ebatında ahşap görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Ahşap",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Ahşap görünümlü porselen kaplama",
      "30X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X120 cm",
      "Ahşap",
      "Tüm Karolar",
      "Faun",
      "Mutfak Karoları"
    ]
  },
  {
    "id": "qua-132-faun-oak-30x120",
    "title": "Faun Oak",
    "collection": "Faun",
    "category": "Mutfak Karoları",
    "sku": "faun-oak-30x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P171BDRN380V0BMAB000-1.jpg"
    ],
    "description": "Faun Oak — Tüm Karolar. 30X120 ebatında ahşap görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Ahşap",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Ahşap görünümlü porselen kaplama",
      "30X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X120 cm",
      "Ahşap",
      "Tüm Karolar",
      "Faun",
      "Mutfak Karoları"
    ]
  },
  {
    "id": "qua-133-firoza-60X120",
    "title": "Firoza",
    "collection": "Firoza",
    "category": "Mutfak Karoları",
    "sku": "firoza-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRFB40X0XFABD10-1.jpg"
    ],
    "description": "Firoza — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Firoza"
    ]
  },
  {
    "id": "qua-134-forest-cherry-30x120",
    "title": "Forest Cherry",
    "collection": "Forest Cherry",
    "category": "Mutfak Karoları",
    "sku": "forest-cherry-30x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P171BDRF330V0BMABB50-1.jpg"
    ],
    "description": "Forest Cherry — Mutfak Karoları. 30X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Forest Cherry"
    ]
  },
  {
    "id": "qua-135-forest-cherry-20x120",
    "title": "Forest Cherry",
    "collection": "Forest Cherry",
    "category": "Mutfak Karoları",
    "sku": "forest-cherry-20x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P171BDRF330V0BMABB50-1.jpg"
    ],
    "description": "Forest Cherry — Mutfak Karoları. 20X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "20X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "20X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "20X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Forest Cherry"
    ]
  },
  {
    "id": "qua-136-forest-dark-30x120",
    "title": "Forest Dark",
    "collection": "Forest",
    "category": "İç Mekan Karoları",
    "sku": "forest-dark-30x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P171BDRF330V0BMABB50-1.jpg"
    ],
    "description": "Forest Dark — Tüm Karolar. 30X120 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "30X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X120 cm",
      "Beton",
      "Tüm Karolar",
      "Forest",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-137-forest-natural-30x120",
    "title": "Forest Natural",
    "collection": "Forest",
    "category": "İç Mekan Karoları",
    "sku": "forest-natural-30x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P171BDRF330V0BMABB50-1.jpg"
    ],
    "description": "Forest Natural — Tüm Karolar. 30X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X120 cm",
      "Porselen",
      "Tüm Karolar",
      "Forest",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-138-forest-natural-20x120",
    "title": "Forest Natural",
    "collection": "Forest",
    "category": "Mutfak Karoları",
    "sku": "forest-natural-20x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P171BDRF330V0BMABB50-1.jpg"
    ],
    "description": "Forest Natural — Mutfak Karoları. 20X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "20X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "20X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "20X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Forest"
    ]
  },
  {
    "id": "qua-139-forest-silver-30x120",
    "title": "Forest Silver",
    "collection": "Forest",
    "category": "İç Mekan Karoları",
    "sku": "forest-silver-30x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P171BDRF330V0BMABB50-1.jpg"
    ],
    "description": "Forest Silver — Tüm Karolar. 30X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X120 cm",
      "Porselen",
      "Tüm Karolar",
      "Forest",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-140-forest-silver-20x120",
    "title": "Forest Silver",
    "collection": "Forest",
    "category": "Mutfak Karoları",
    "sku": "forest-silver-20x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P171BDRF330V0BMABB50-1.jpg"
    ],
    "description": "Forest Silver — Mutfak Karoları. 20X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "20X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "20X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "20X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Forest"
    ]
  },
  {
    "id": "qua-141-gaios-60X120",
    "title": "Gaios",
    "collection": "Gaios",
    "category": "Mutfak Karoları",
    "sku": "gaios-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRG390X0XFABD10-1.jpg"
    ],
    "description": "Gaios — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Gaios"
    ]
  },
  {
    "id": "qua-142-ginza-blue-60X120",
    "title": "Ginza Blue",
    "collection": "Ginza Blue",
    "category": "Mutfak Karoları",
    "sku": "ginza-blue-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDR35V0X0XFABI00-1.jpg"
    ],
    "description": "Ginza Blue — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Ginza Blue"
    ]
  },
  {
    "id": "qua-143-ginza-ivory-60X120",
    "title": "Ginza Ivory",
    "collection": "Ginza",
    "category": "Mutfak Karoları",
    "sku": "ginza-ivory-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDR35V0X0XFABI00-1.jpg"
    ],
    "description": "Ginza Ivory — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Ginza"
    ]
  },
  {
    "id": "qua-144-ginza-mint-60X120",
    "title": "Ginza Mint",
    "collection": "Ginza Mint",
    "category": "Mutfak Karoları",
    "sku": "ginza-mint-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDR35V0X0XFABI00-1.jpg"
    ],
    "description": "Ginza Mint — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Ginza Mint"
    ]
  },
  {
    "id": "qua-145-ginza-white-60X120",
    "title": "Ginza White",
    "collection": "Ginza",
    "category": "Mutfak Karoları",
    "sku": "ginza-white-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDR35V0X0XFABI00-1.jpg"
    ],
    "description": "Ginza White — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Ginza"
    ]
  },
  {
    "id": "qua-146-grava-anthracite-60X60",
    "title": "Grava Anthracite",
    "collection": "Grava",
    "category": "İç Mekan Karoları",
    "sku": "grava-anthracite-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRG510V0BGABG40-1.jpg"
    ],
    "description": "Grava Anthracite — Tüm Karolar. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Tüm Karolar",
      "Grava",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-147-grava-anthracite-60X120",
    "title": "Grava Anthracite",
    "collection": "Grava",
    "category": "İç Mekan Karoları",
    "sku": "grava-anthracite-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRG510V0BGABG40-1.jpg"
    ],
    "description": "Grava Anthracite — Tüm Karolar. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Tüm Karolar",
      "Grava",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-148-grava-gris-60X60",
    "title": "Grava Gris",
    "collection": "Grava Gris",
    "category": "İç Mekan Karoları",
    "sku": "grava-gris-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRG510V0BGABG40-1.jpg"
    ],
    "description": "Grava Gris — Tüm Karolar. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Tüm Karolar",
      "Grava Gris",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-149-grava-gris-60X120",
    "title": "Grava Gris",
    "collection": "Grava Gris",
    "category": "İç Mekan Karoları",
    "sku": "grava-gris-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRG510V0BGABG40-1.jpg"
    ],
    "description": "Grava Gris — Tüm Karolar. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Tüm Karolar",
      "Grava Gris",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-150-gris-travertino-60X60",
    "title": "Gris Travertino",
    "collection": "Gris Travertino",
    "category": "Mutfak Karoları",
    "sku": "gris-travertino-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCT280X0XMABD10-1.jpg"
    ],
    "description": "Gris Travertino — Mutfak Karoları. 60X60 ebatında travertin görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Travertin",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Travertin görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Travertin",
      "Mutfak Karoları",
      "Gris Travertino"
    ]
  },
  {
    "id": "qua-151-gris-travertino-60X120",
    "title": "Gris Travertino",
    "collection": "Gris Travertino",
    "category": "Mutfak Karoları",
    "sku": "gris-travertino-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCT280X0XMABD10-1.jpg"
    ],
    "description": "Gris Travertino — Mutfak Karoları. 60X120 ebatında travertin görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Travertin",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Travertin görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Travertin",
      "Mutfak Karoları",
      "Gris Travertino"
    ]
  },
  {
    "id": "qua-152-gris-travertino-30x60",
    "title": "Gris Travertino",
    "collection": "Gris Travertino",
    "category": "Mutfak Karoları",
    "sku": "gris-travertino-30x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCT280X0XMABD10-1.jpg"
    ],
    "description": "Gris Travertino — Mutfak Karoları. 30X60 ebatında travertin görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Travertin",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Travertin görünümlü porselen kaplama",
      "30X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X60 cm",
      "Travertin",
      "Mutfak Karoları",
      "Gris Travertino"
    ]
  },
  {
    "id": "qua-153-grovak-anthracite-60X120",
    "title": "Grovak Anthracite",
    "collection": "Grovak",
    "category": "İç Mekan Karoları",
    "sku": "grovak-anthracite-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRG490X0XGABW00-1.jpg"
    ],
    "description": "Grovak Anthracite — Tüm Karolar. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Tüm Karolar",
      "Grovak",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-154-grovak-anthracite-60x90",
    "title": "Grovak Anthracite",
    "collection": "Grovak",
    "category": "İç Mekan Karoları",
    "sku": "grovak-anthracite-60x90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRG490X0XGABW00-1.jpg"
    ],
    "description": "Grovak Anthracite — Tüm Karolar. 60X90 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X90 cm",
      "Porselen",
      "Tüm Karolar",
      "Grovak",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-155-grovak-white-60X60",
    "title": "Grovak White",
    "collection": "Grovak",
    "category": "İç Mekan Karoları",
    "sku": "grovak-white-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRG490X0XGABW00-1.jpg"
    ],
    "description": "Grovak White — Tüm Karolar. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Tüm Karolar",
      "Grovak",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-156-grovak-white-60X120",
    "title": "Grovak White",
    "collection": "Grovak",
    "category": "İç Mekan Karoları",
    "sku": "grovak-white-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRG490X0XGABW00-1.jpg"
    ],
    "description": "Grovak White — Tüm Karolar. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Tüm Karolar",
      "Grovak",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-157-grovak-white-60x90",
    "title": "Grovak White",
    "collection": "Grovak",
    "category": "İç Mekan Karoları",
    "sku": "grovak-white-60x90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRG490X0XGABW00-1.jpg"
    ],
    "description": "Grovak White — Tüm Karolar. 60X90 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X90 cm",
      "Porselen",
      "Tüm Karolar",
      "Grovak",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-158-gusto-white-30x60",
    "title": "Gusto White",
    "collection": "Gusto",
    "category": "Mutfak Karoları",
    "sku": "gusto-white-30x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/W010ZD0G360X0XMABW50-1.jpg"
    ],
    "description": "Gusto White — Mutfak Karoları. 30X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Gusto"
    ]
  },
  {
    "id": "qua-159-hardy-arce-15X60",
    "title": "Hardy Arce",
    "collection": "Hardy Arce",
    "category": "Mutfak Karoları",
    "sku": "hardy-arce-15X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/G038XD0H370V0XMABB40-1.jpg"
    ],
    "description": "Hardy Arce — Mutfak Karoları. 15X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "15X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "15X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "15X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Hardy Arce"
    ]
  },
  {
    "id": "qua-160-hardy-grey-15X60",
    "title": "Hardy Grey",
    "collection": "Hardy",
    "category": "Mutfak Karoları",
    "sku": "hardy-grey-15X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/G038XD0H370V0XMABB40-1.jpg"
    ],
    "description": "Hardy Grey — Mutfak Karoları. 15X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "15X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "15X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "15X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Hardy"
    ]
  },
  {
    "id": "qua-161-hardy-natural-15X60",
    "title": "Hardy Natural",
    "collection": "Hardy",
    "category": "Mutfak Karoları",
    "sku": "hardy-natural-15X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/G038XD0H370V0XMABB40-1.jpg"
    ],
    "description": "Hardy Natural — Mutfak Karoları. 15X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "15X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "15X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "15X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Hardy"
    ]
  },
  {
    "id": "qua-162-hardy-natural-20x120",
    "title": "Hardy Natural",
    "collection": "Hardy",
    "category": "Mutfak Karoları",
    "sku": "hardy-natural-20x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/G038XD0H370V0XMABB40-1.jpg"
    ],
    "description": "Hardy Natural — Mutfak Karoları. 20X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "20X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "20X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "20X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Hardy"
    ]
  },
  {
    "id": "qua-163-hardy-nogal-15X60",
    "title": "Hardy Nogal",
    "collection": "Hardy Nogal",
    "category": "Mutfak Karoları",
    "sku": "hardy-nogal-15X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/G038XD0H370V0XMABB40-1.jpg"
    ],
    "description": "Hardy Nogal — Mutfak Karoları. 15X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "15X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "15X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "15X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Hardy Nogal"
    ]
  },
  {
    "id": "qua-164-herringbone-honey-60X120",
    "title": "Herringbone Honey",
    "collection": "Herringbone",
    "category": "Mutfak Karoları",
    "sku": "herringbone-honey-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDR54V0X0XKABOA0-1.jpg"
    ],
    "description": "Herringbone Honey — Mutfak Karoları. 60X120 ebatında ahşap görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Ahşap",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Ahşap görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Ahşap",
      "Mutfak Karoları",
      "Herringbone"
    ]
  },
  {
    "id": "qua-165-herringbone-oak-60X120",
    "title": "Herringbone Oak",
    "collection": "Herringbone",
    "category": "Mutfak Karoları",
    "sku": "herringbone-oak-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDR54V0X0XKABOA0-1.jpg"
    ],
    "description": "Herringbone Oak — Mutfak Karoları. 60X120 ebatında ahşap görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Ahşap",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Ahşap görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Ahşap",
      "Mutfak Karoları",
      "Herringbone"
    ]
  },
  {
    "id": "qua-166-hielo-dark-60X120",
    "title": "Hielo Dark",
    "collection": "Hielo",
    "category": "Mutfak Karoları",
    "sku": "hielo-dark-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRH470X0XFABD00-1.jpg"
    ],
    "description": "Hielo Dark — Mutfak Karoları. 60X120 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Beton",
      "Mutfak Karoları",
      "Hielo"
    ]
  },
  {
    "id": "qua-167-hielo-light-60X120",
    "title": "Hielo Light",
    "collection": "Hielo",
    "category": "Mutfak Karoları",
    "sku": "hielo-light-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRH470X0XFABD00-1.jpg"
    ],
    "description": "Hielo Light — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Hielo"
    ]
  },
  {
    "id": "qua-168-holmes-beyaz-",
    "title": "Holmes Beyaz",
    "collection": "Holmes Beyaz",
    "category": "Mutfak Karoları",
    "sku": "holmes-beyaz-",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRH360X0XPABW50-1.jpg"
    ],
    "description": "Holmes Beyaz — Mutfak Karoları. 30X90 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X90 cm",
      "Porselen",
      "Mutfak Karoları",
      "Holmes Beyaz"
    ]
  },
  {
    "id": "qua-169-holmes-geometrik-dekofon-30X90",
    "title": "Holmes Geometrik Dekofon",
    "collection": "Holmes Geometrik Dekofon",
    "category": "Mutfak Karoları",
    "sku": "holmes-geometrik-dekofon-30X90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRH360X0XPABW50-1.jpg"
    ],
    "description": "Holmes Geometrik Dekofon — Mutfak Karoları. 30X90 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X90 cm",
      "Yüzey": "3D Yüzey",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X90 cm ebat",
      "3D Yüzey yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X90 cm",
      "Porselen",
      "Mutfak Karoları",
      "3D Yüzey",
      "Holmes Geometrik Dekofon"
    ]
  },
  {
    "id": "qua-170-holmes-white-60X60",
    "title": "Holmes White",
    "collection": "Holmes",
    "category": "Mutfak Karoları",
    "sku": "holmes-white-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRH360X0XPABW50-1.jpg"
    ],
    "description": "Holmes White — Mutfak Karoları. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Holmes"
    ]
  },
  {
    "id": "qua-171-holmes-white-dekofon-30X90",
    "title": "Holmes White Dekofon",
    "collection": "Holmes White Dekofon",
    "category": "Mutfak Karoları",
    "sku": "holmes-white-dekofon-30X90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRH360X0XPABW50-1.jpg"
    ],
    "description": "Holmes White Dekofon — Mutfak Karoları. 30X90 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X90 cm",
      "Yüzey": "3D Yüzey",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X90 cm ebat",
      "3D Yüzey yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X90 cm",
      "Porselen",
      "Mutfak Karoları",
      "3D Yüzey",
      "Holmes White Dekofon"
    ]
  },
  {
    "id": "qua-172-hoxton-beige-30x60",
    "title": "Hoxton Beige",
    "collection": "Hoxton",
    "category": "Mutfak Karoları",
    "sku": "hoxton-beige-30x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/W010ZD0E59010XMABB50-1.jpg"
    ],
    "description": "Hoxton Beige — Mutfak Karoları. 30X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Hoxton"
    ]
  },
  {
    "id": "qua-173-hoxton-grey-30x60",
    "title": "Hoxton Grey",
    "collection": "Hoxton",
    "category": "Mutfak Karoları",
    "sku": "hoxton-grey-30x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/W010ZD0E59010XMABB50-1.jpg"
    ],
    "description": "Hoxton Grey — Mutfak Karoları. 30X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Hoxton"
    ]
  },
  {
    "id": "qua-174-hoxton-grey-dekofon-30x60",
    "title": "Hoxton Grey Dekofon",
    "collection": "Hoxton Grey Dekofon",
    "category": "Mutfak Karoları",
    "sku": "hoxton-grey-dekofon-30x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/W010ZD0E59010XMABB50-1.jpg"
    ],
    "description": "Hoxton Grey Dekofon — Mutfak Karoları. 30X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X60 cm",
      "Yüzey": "3D Yüzey",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X60 cm ebat",
      "3D Yüzey yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "3D Yüzey",
      "Hoxton Grey Dekofon"
    ]
  },
  {
    "id": "qua-175-julian-60X60",
    "title": "Julian",
    "collection": "Julian",
    "category": "Mutfak Karoları",
    "sku": "julian-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015ZDRJ140X0XPABD10-1.jpg"
    ],
    "description": "Julian — Mutfak Karoları. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Julian"
    ]
  },
  {
    "id": "qua-176-kandla-grey-60x90",
    "title": "Kandla Grey",
    "collection": "Kandla",
    "category": "İç Mekan Karoları",
    "sku": "kandla-grey-60x90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P174BDRK460X0XGABGR0-1.jpg"
    ],
    "description": "Kandla Grey — Tüm Karolar. 60X90 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X90 cm",
      "Porselen",
      "Tüm Karolar",
      "Kandla",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-177-lagom-anthracite-30x60",
    "title": "Lagom Anthracite",
    "collection": "Lagom",
    "category": "Mutfak Karoları",
    "sku": "lagom-anthracite-30x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRL840V0XMABGR0-1.jpg"
    ],
    "description": "Lagom Anthracite — Mutfak Karoları. 30X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Lagom"
    ]
  },
  {
    "id": "qua-178-lagom-anthracite-60X60",
    "title": "Lagom Anthracite",
    "collection": "Lagom",
    "category": "Mutfak Karoları",
    "sku": "lagom-anthracite-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRL840V0XMABGR0-1.jpg"
    ],
    "description": "Lagom Anthracite — Mutfak Karoları. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Lagom"
    ]
  },
  {
    "id": "qua-179-lagom-anthracite-60X120",
    "title": "Lagom Anthracite",
    "collection": "Lagom",
    "category": "İç Mekan Karoları",
    "sku": "lagom-anthracite-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRL840V0XMABGR0-1.jpg"
    ],
    "description": "Lagom Anthracite — Tüm Karolar. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Tüm Karolar",
      "Lagom",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-180-lagom-anthracite-30x40",
    "title": "Lagom Anthracite",
    "collection": "Lagom",
    "category": "Mutfak Karoları",
    "sku": "lagom-anthracite-30x40",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRL840V0XMABGR0-1.jpg"
    ],
    "description": "Lagom Anthracite — Mutfak Karoları. 30X40 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X40 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X40 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X40 cm",
      "Porselen",
      "Mutfak Karoları",
      "Lagom"
    ]
  },
  {
    "id": "qua-181-lagom-gra-30x60",
    "title": "Lagom Gra",
    "collection": "Lagom Gra",
    "category": "Mutfak Karoları",
    "sku": "lagom-gra-30x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRL840V0XMABGR0-1.jpg"
    ],
    "description": "Lagom Gra — Mutfak Karoları. 30X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Lagom Gra"
    ]
  },
  {
    "id": "qua-182-lagom-gra-60X60",
    "title": "Lagom Gra",
    "collection": "Lagom Gra",
    "category": "Mutfak Karoları",
    "sku": "lagom-gra-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRL840V0XMABGR0-1.jpg"
    ],
    "description": "Lagom Gra — Mutfak Karoları. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Lagom Gra"
    ]
  },
  {
    "id": "qua-183-lagom-gra-60X120",
    "title": "Lagom Gra",
    "collection": "Lagom Gra",
    "category": "İç Mekan Karoları",
    "sku": "lagom-gra-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRL840V0XMABGR0-1.jpg"
    ],
    "description": "Lagom Gra — Tüm Karolar. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Tüm Karolar",
      "Lagom Gra",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-184-lagom-gra-30x40",
    "title": "Lagom Gra",
    "collection": "Lagom Gra",
    "category": "Mutfak Karoları",
    "sku": "lagom-gra-30x40",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRL840V0XMABGR0-1.jpg"
    ],
    "description": "Lagom Gra — Mutfak Karoları. 30X40 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X40 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X40 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X40 cm",
      "Porselen",
      "Mutfak Karoları",
      "Lagom Gra"
    ]
  },
  {
    "id": "qua-185-lagom-sand-30x60",
    "title": "Lagom Sand",
    "collection": "Lagom",
    "category": "Mutfak Karoları",
    "sku": "lagom-sand-30x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRL840V0XMABGR0-1.jpg"
    ],
    "description": "Lagom Sand — Mutfak Karoları. 30X60 ebatında taş görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Taş",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Taş görünümlü porselen kaplama",
      "30X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X60 cm",
      "Taş",
      "Mutfak Karoları",
      "Lagom"
    ]
  },
  {
    "id": "qua-186-lagom-sand-60X60",
    "title": "Lagom Sand",
    "collection": "Lagom",
    "category": "Mutfak Karoları",
    "sku": "lagom-sand-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRL840V0XMABGR0-1.jpg"
    ],
    "description": "Lagom Sand — Mutfak Karoları. 60X60 ebatında taş görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Taş",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Taş görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Taş",
      "Mutfak Karoları",
      "Lagom"
    ]
  },
  {
    "id": "qua-187-lagom-sand-60X120",
    "title": "Lagom Sand",
    "collection": "Lagom",
    "category": "İç Mekan Karoları",
    "sku": "lagom-sand-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRL840V0XMABGR0-1.jpg"
    ],
    "description": "Lagom Sand — Tüm Karolar. 60X120 ebatında taş görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Taş",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Taş görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Taş",
      "Tüm Karolar",
      "Lagom",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-188-lagom-sand-30x40",
    "title": "Lagom Sand",
    "collection": "Lagom",
    "category": "Mutfak Karoları",
    "sku": "lagom-sand-30x40",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRL840V0XMABGR0-1.jpg"
    ],
    "description": "Lagom Sand — Mutfak Karoları. 30X40 ebatında taş görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X40 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Taş",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Taş görünümlü porselen kaplama",
      "30X40 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X40 cm",
      "Taş",
      "Mutfak Karoları",
      "Lagom"
    ]
  },
  {
    "id": "qua-189-lave-blanche-60X120",
    "title": "Lave Blanche",
    "collection": "Lave Blanche",
    "category": "Mutfak Karoları",
    "sku": "lave-blanche-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRL970X0XFABBN0-1.jpg"
    ],
    "description": "Lave Blanche — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Lave Blanche"
    ]
  },
  {
    "id": "qua-190-lave-dore-60X120",
    "title": "Lave Dore",
    "collection": "Lave Dore",
    "category": "Mutfak Karoları",
    "sku": "lave-dore-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRL970X0XFABBN0-1.jpg"
    ],
    "description": "Lave Dore — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Lave Dore"
    ]
  },
  {
    "id": "qua-191-luna-ah-30x40",
    "title": "Luna Ah",
    "collection": "Luna Ah",
    "category": "Mutfak Karoları",
    "sku": "luna-ah-30x40",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Ah — Mutfak Karoları. 30X40 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X40 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X40 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X40 cm",
      "Porselen",
      "Mutfak Karoları",
      "Luna Ah"
    ]
  },
  {
    "id": "qua-192-luna-ash-60X60",
    "title": "Luna Ash",
    "collection": "Luna Ash",
    "category": "Mutfak Karoları",
    "sku": "luna-ash-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Ash — Mutfak Karoları. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Luna Ash"
    ]
  },
  {
    "id": "qua-193-luna-ash-60X120",
    "title": "Luna Ash",
    "collection": "Luna Ash",
    "category": "İç Mekan Karoları",
    "sku": "luna-ash-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Ash — Tüm Karolar. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Tüm Karolar",
      "Luna Ash",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-194-luna-ash-80x80",
    "title": "Luna Ash",
    "collection": "Luna Ash",
    "category": "İç Mekan Karoları",
    "sku": "luna-ash-80x80",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Ash — Tüm Karolar. 80X80 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "80X80 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "80X80 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "80X80 cm",
      "Porselen",
      "Tüm Karolar",
      "Luna Ash",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-195-luna-ash-197x197",
    "title": "Luna Ash",
    "collection": "Luna Ash",
    "category": "Mutfak Karoları",
    "sku": "luna-ash-197x197",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Ash — Mutfak Karoları. 19 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "19 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "19 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "19 cm",
      "Porselen",
      "Mutfak Karoları",
      "Luna Ash"
    ]
  },
  {
    "id": "qua-196-luna-ash-20x40",
    "title": "Luna Ash",
    "collection": "Luna Ash",
    "category": "Mutfak Karoları",
    "sku": "luna-ash-20x40",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Ash — Mutfak Karoları. 20X40 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "20X40 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "20X40 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "20X40 cm",
      "Porselen",
      "Mutfak Karoları",
      "Luna Ash"
    ]
  },
  {
    "id": "qua-197-luna-cool-grey-30x60",
    "title": "Luna Cool Grey",
    "collection": "Luna Cool",
    "category": "Mutfak Karoları",
    "sku": "luna-cool-grey-30x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Cool Grey — Mutfak Karoları. 30X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Luna Cool"
    ]
  },
  {
    "id": "qua-198-luna-cool-grey-60X60",
    "title": "Luna Cool Grey",
    "collection": "Luna Cool",
    "category": "Mutfak Karoları",
    "sku": "luna-cool-grey-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Cool Grey — Mutfak Karoları. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Luna Cool"
    ]
  },
  {
    "id": "qua-199-luna-cool-grey-61x61",
    "title": "Luna Cool Grey",
    "collection": "Luna Cool",
    "category": "Mutfak Karoları",
    "sku": "luna-cool-grey-61x61",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Cool Grey — Mutfak Karoları. 61X61 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "61X61 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "61X61 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "61X61 cm",
      "Porselen",
      "Mutfak Karoları",
      "Luna Cool"
    ]
  },
  {
    "id": "qua-200-luna-cool-grey-60X120",
    "title": "Luna Cool Grey",
    "collection": "Luna Cool",
    "category": "İç Mekan Karoları",
    "sku": "luna-cool-grey-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Cool Grey — Tüm Karolar. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Tüm Karolar",
      "Luna Cool",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-201-luna-cool-grey-60x90",
    "title": "Luna Cool Grey",
    "collection": "Luna Cool",
    "category": "İç Mekan Karoları",
    "sku": "luna-cool-grey-60x90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Cool Grey — Tüm Karolar. 60X90 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X90 cm",
      "Porselen",
      "Tüm Karolar",
      "Luna Cool",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-202-luna-cool-grey-80x80",
    "title": "Luna Cool Grey",
    "collection": "Luna Cool",
    "category": "İç Mekan Karoları",
    "sku": "luna-cool-grey-80x80",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Cool Grey — Tüm Karolar. 80X80 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "80X80 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "80X80 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "80X80 cm",
      "Porselen",
      "Tüm Karolar",
      "Luna Cool",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-203-luna-cool-grey-197x197",
    "title": "Luna Cool Grey",
    "collection": "Luna Cool",
    "category": "Mutfak Karoları",
    "sku": "luna-cool-grey-197x197",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Cool Grey — Mutfak Karoları. 19 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "19 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "19 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "19 cm",
      "Porselen",
      "Mutfak Karoları",
      "Luna Cool"
    ]
  },
  {
    "id": "qua-204-luna-cool-grey-30x40",
    "title": "Luna Cool Grey",
    "collection": "Luna Cool",
    "category": "Mutfak Karoları",
    "sku": "luna-cool-grey-30x40",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Cool Grey — Mutfak Karoları. 30X40 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X40 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X40 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X40 cm",
      "Porselen",
      "Mutfak Karoları",
      "Luna Cool"
    ]
  },
  {
    "id": "qua-205-luna-cool-grey-20x40",
    "title": "Luna Cool Grey",
    "collection": "Luna Cool",
    "category": "Mutfak Karoları",
    "sku": "luna-cool-grey-20x40",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Cool Grey — Mutfak Karoları. 20X40 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "20X40 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "20X40 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "20X40 cm",
      "Porselen",
      "Mutfak Karoları",
      "Luna Cool"
    ]
  },
  {
    "id": "qua-206-luna-cooper-197x197",
    "title": "Luna Cooper",
    "collection": "Luna Cooper",
    "category": "Mutfak Karoları",
    "sku": "luna-cooper-197x197",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Cooper — Mutfak Karoları. 19 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "19 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "19 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "19 cm",
      "Porselen",
      "Mutfak Karoları",
      "Luna Cooper"
    ]
  },
  {
    "id": "qua-207-luna-cooper-20x40",
    "title": "Luna Cooper",
    "collection": "Luna Cooper",
    "category": "Mutfak Karoları",
    "sku": "luna-cooper-20x40",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Cooper — Mutfak Karoları. 20X40 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "20X40 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "20X40 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "20X40 cm",
      "Porselen",
      "Mutfak Karoları",
      "Luna Cooper"
    ]
  },
  {
    "id": "qua-208-luna-cooper-60X60",
    "title": "Luna Cooper",
    "collection": "Luna Cooper",
    "category": "Mutfak Karoları",
    "sku": "luna-cooper-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Cooper — Mutfak Karoları. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Luna Cooper"
    ]
  },
  {
    "id": "qua-209-luna-copper-60X120",
    "title": "Luna Copper",
    "collection": "Luna Copper",
    "category": "Mutfak Karoları",
    "sku": "luna-copper-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Copper — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Luna Copper"
    ]
  },
  {
    "id": "qua-210-luna-copper-30x40",
    "title": "Luna Copper",
    "collection": "Luna Copper",
    "category": "Mutfak Karoları",
    "sku": "luna-copper-30x40",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Copper — Mutfak Karoları. 30X40 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X40 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X40 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X40 cm",
      "Porselen",
      "Mutfak Karoları",
      "Luna Copper"
    ]
  },
  {
    "id": "qua-211-luna-luna-copper-30x60",
    "title": "Luna Luna Copper",
    "collection": "Luna Luna Copper",
    "category": "Mutfak Karoları",
    "sku": "luna-luna-copper-30x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Luna Copper — Mutfak Karoları. 30X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Luna Luna Copper"
    ]
  },
  {
    "id": "qua-212-luna-mid-grey-60X60",
    "title": "Luna Mid Grey",
    "collection": "Luna Mid",
    "category": "Mutfak Karoları",
    "sku": "luna-mid-grey-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Mid Grey — Mutfak Karoları. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Luna Mid"
    ]
  },
  {
    "id": "qua-213-luna-mid-grey-60X120",
    "title": "Luna Mid Grey",
    "collection": "Luna Mid",
    "category": "İç Mekan Karoları",
    "sku": "luna-mid-grey-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Mid Grey — Tüm Karolar. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Tüm Karolar",
      "Luna Mid",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-214-luna-middle-grey-197x197",
    "title": "Luna Middle Grey",
    "collection": "Luna Middle",
    "category": "Mutfak Karoları",
    "sku": "luna-middle-grey-197x197",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Middle Grey — Mutfak Karoları. 19 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "19 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "19 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "19 cm",
      "Porselen",
      "Mutfak Karoları",
      "Luna Middle"
    ]
  },
  {
    "id": "qua-215-luna-middle-grey-30x40",
    "title": "Luna Middle Grey",
    "collection": "Luna Middle",
    "category": "Mutfak Karoları",
    "sku": "luna-middle-grey-30x40",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Middle Grey — Mutfak Karoları. 30X40 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X40 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X40 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X40 cm",
      "Porselen",
      "Mutfak Karoları",
      "Luna Middle"
    ]
  },
  {
    "id": "qua-216-luna-middle-grey-20x40",
    "title": "Luna Middle Grey",
    "collection": "Luna Middle",
    "category": "Mutfak Karoları",
    "sku": "luna-middle-grey-20x40",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Middle Grey — Mutfak Karoları. 20X40 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "20X40 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "20X40 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "20X40 cm",
      "Porselen",
      "Mutfak Karoları",
      "Luna Middle"
    ]
  },
  {
    "id": "qua-217-luna-offwhite-60X60",
    "title": "Luna Offwhite",
    "collection": "Luna Offwhite",
    "category": "Mutfak Karoları",
    "sku": "luna-offwhite-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Offwhite — Mutfak Karoları. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Luna Offwhite"
    ]
  },
  {
    "id": "qua-218-luna-offwhite-60X120",
    "title": "Luna Offwhite",
    "collection": "Luna Offwhite",
    "category": "İç Mekan Karoları",
    "sku": "luna-offwhite-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Offwhite — Tüm Karolar. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Tüm Karolar",
      "Luna Offwhite",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-219-luna-offwhite-60x90",
    "title": "Luna Offwhite",
    "collection": "Luna Offwhite",
    "category": "İç Mekan Karoları",
    "sku": "luna-offwhite-60x90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Offwhite — Tüm Karolar. 60X90 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X90 cm",
      "Porselen",
      "Tüm Karolar",
      "Luna Offwhite",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-220-luna-offwhite-80x80",
    "title": "Luna Offwhite",
    "collection": "Luna Offwhite",
    "category": "İç Mekan Karoları",
    "sku": "luna-offwhite-80x80",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Offwhite — Tüm Karolar. 80X80 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "80X80 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "80X80 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "80X80 cm",
      "Porselen",
      "Tüm Karolar",
      "Luna Offwhite",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-221-luna-offwhite-197x197",
    "title": "Luna Offwhite",
    "collection": "Luna Offwhite",
    "category": "Mutfak Karoları",
    "sku": "luna-offwhite-197x197",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Offwhite — Mutfak Karoları. 19 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "19 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "19 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "19 cm",
      "Porselen",
      "Mutfak Karoları",
      "Luna Offwhite"
    ]
  },
  {
    "id": "qua-222-luna-offwhite-30x40",
    "title": "Luna Offwhite",
    "collection": "Luna Offwhite",
    "category": "Mutfak Karoları",
    "sku": "luna-offwhite-30x40",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Offwhite — Mutfak Karoları. 30X40 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X40 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X40 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X40 cm",
      "Porselen",
      "Mutfak Karoları",
      "Luna Offwhite"
    ]
  },
  {
    "id": "qua-223-luna-offwhite-30x60",
    "title": "Luna Offwhite",
    "collection": "Luna Offwhite",
    "category": "Mutfak Karoları",
    "sku": "luna-offwhite-30x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Offwhite — Mutfak Karoları. 30X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Luna Offwhite"
    ]
  },
  {
    "id": "qua-224-luna-sand-30x60",
    "title": "Luna Sand",
    "collection": "Luna",
    "category": "Mutfak Karoları",
    "sku": "luna-sand-30x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Sand — Mutfak Karoları. 30X60 ebatında taş görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Taş",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Taş görünümlü porselen kaplama",
      "30X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X60 cm",
      "Taş",
      "Mutfak Karoları",
      "Luna"
    ]
  },
  {
    "id": "qua-225-luna-sand-60X60",
    "title": "Luna Sand",
    "collection": "Luna",
    "category": "İç Mekan Karoları",
    "sku": "luna-sand-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Sand — Tüm Karolar. 60X60 ebatında taş görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Taş",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Taş görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Taş",
      "Tüm Karolar",
      "Luna",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-226-luna-sand-61x61",
    "title": "Luna Sand",
    "collection": "Luna",
    "category": "Mutfak Karoları",
    "sku": "luna-sand-61x61",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Sand — Mutfak Karoları. 61X61 ebatında taş görünümlü porselen karo.",
    "specs": {
      "Ebat": "61X61 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Taş",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Taş görünümlü porselen kaplama",
      "61X61 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "61X61 cm",
      "Taş",
      "Mutfak Karoları",
      "Luna"
    ]
  },
  {
    "id": "qua-227-luna-sand-60X120",
    "title": "Luna Sand",
    "collection": "Luna",
    "category": "İç Mekan Karoları",
    "sku": "luna-sand-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Sand — Tüm Karolar. 60X120 ebatında taş görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Taş",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Taş görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Taş",
      "Tüm Karolar",
      "Luna",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-228-luna-sand-80x80",
    "title": "Luna Sand",
    "collection": "Luna",
    "category": "İç Mekan Karoları",
    "sku": "luna-sand-80x80",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Sand — Tüm Karolar. 80X80 ebatında taş görünümlü porselen karo.",
    "specs": {
      "Ebat": "80X80 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Taş",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Taş görünümlü porselen kaplama",
      "80X80 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "80X80 cm",
      "Taş",
      "Tüm Karolar",
      "Luna",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-229-luna-sand-197x197",
    "title": "Luna Sand",
    "collection": "Luna",
    "category": "Mutfak Karoları",
    "sku": "luna-sand-197x197",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Sand — Mutfak Karoları. 19 ebatında taş görünümlü porselen karo.",
    "specs": {
      "Ebat": "19 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Taş",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Taş görünümlü porselen kaplama",
      "19 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "19 cm",
      "Taş",
      "Mutfak Karoları",
      "Luna"
    ]
  },
  {
    "id": "qua-230-luna-sand-30x40",
    "title": "Luna Sand",
    "collection": "Luna",
    "category": "Mutfak Karoları",
    "sku": "luna-sand-30x40",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Sand — Mutfak Karoları. 30X40 ebatında taş görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X40 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Taş",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Taş görünümlü porselen kaplama",
      "30X40 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X40 cm",
      "Taş",
      "Mutfak Karoları",
      "Luna"
    ]
  },
  {
    "id": "qua-231-luna-sans-60X60",
    "title": "Luna Sans",
    "collection": "Luna Sans",
    "category": "Mutfak Karoları",
    "sku": "luna-sans-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCL220X0AMABCG0-1.jpg"
    ],
    "description": "Luna Sans — Mutfak Karoları. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Luna Sans"
    ]
  },
  {
    "id": "qua-232-luz-sole-60x110",
    "title": "Luz Sole",
    "collection": "Luz Sole",
    "category": "Mutfak Karoları",
    "sku": "luz-sole-60x110",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRV620X0XFABBN0-1.jpg"
    ],
    "description": "Luz Sole — Mutfak Karoları. 60X110 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X110 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X110 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X110 cm",
      "Porselen",
      "Mutfak Karoları",
      "Luz Sole"
    ]
  },
  {
    "id": "qua-233-manoir-oak-20x120",
    "title": "Manoir Oak",
    "collection": "Manoir",
    "category": "Mutfak Karoları",
    "sku": "manoir-oak-20x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P192ZDRMS30X0XMABOA0-1.jpg"
    ],
    "description": "Manoir Oak — Mutfak Karoları. 20X120 ebatında ahşap görünümlü porselen karo.",
    "specs": {
      "Ebat": "20X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Ahşap",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Ahşap görünümlü porselen kaplama",
      "20X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "20X120 cm",
      "Ahşap",
      "Mutfak Karoları",
      "Manoir"
    ]
  },
  {
    "id": "qua-234-manoir-walnut-20x120",
    "title": "Manoir Walnut",
    "collection": "Manoir",
    "category": "Mutfak Karoları",
    "sku": "manoir-walnut-20x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P192ZDRMS30X0XMABOA0-1.jpg"
    ],
    "description": "Manoir Walnut — Mutfak Karoları. 20X120 ebatında ahşap görünümlü porselen karo.",
    "specs": {
      "Ebat": "20X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Ahşap",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Ahşap görünümlü porselen kaplama",
      "20X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "20X120 cm",
      "Ahşap",
      "Mutfak Karoları",
      "Manoir"
    ]
  },
  {
    "id": "qua-235-mapstone-beige-60X120",
    "title": "Mapstone Beige",
    "collection": "Mapstone",
    "category": "Mutfak Karoları",
    "sku": "mapstone-beige-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRMR70X0XGABBO0-1.jpg"
    ],
    "description": "Mapstone Beige — Mutfak Karoları. 60X120 ebatında taş görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Taş",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Taş görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Taş",
      "Mutfak Karoları",
      "Mapstone"
    ]
  },
  {
    "id": "qua-236-mapstone-grey-60X120",
    "title": "Mapstone Grey",
    "collection": "Mapstone",
    "category": "Mutfak Karoları",
    "sku": "mapstone-grey-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRMR70X0XGABBO0-1.jpg"
    ],
    "description": "Mapstone Grey — Mutfak Karoları. 60X120 ebatında taş görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Taş",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Taş görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Taş",
      "Mutfak Karoları",
      "Mapstone"
    ]
  },
  {
    "id": "qua-237-mapstone-pearl-60X120",
    "title": "Mapstone Pearl",
    "collection": "Mapstone Pearl",
    "category": "Mutfak Karoları",
    "sku": "mapstone-pearl-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRMR70X0XGABBO0-1.jpg"
    ],
    "description": "Mapstone Pearl — Mutfak Karoları. 60X120 ebatında taş görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Taş",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Taş görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Taş",
      "Mutfak Karoları",
      "Mapstone Pearl"
    ]
  },
  {
    "id": "qua-238-marfil-rosso-60X120",
    "title": "Marfil Rosso",
    "collection": "Marfil Rosso",
    "category": "Mutfak Karoları",
    "sku": "marfil-rosso-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRM860X0XFABD10-1.jpg"
    ],
    "description": "Marfil Rosso — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Marfil Rosso"
    ]
  },
  {
    "id": "qua-239-marine-20x120",
    "title": "Marine",
    "collection": "Marine",
    "category": "Mutfak Karoları",
    "sku": "marine-20x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P192ZDRMS40V0XMABD10-1.jpg"
    ],
    "description": "Marine — Mutfak Karoları. 20X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "20X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "20X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "20X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Marine"
    ]
  },
  {
    "id": "qua-240-marjinal-beyaz-60X60",
    "title": "Marjinal Beyaz",
    "collection": "Marjinal Beyaz",
    "category": "Mutfak Karoları",
    "sku": "marjinal-beyaz-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015ZDRMM10X0XFABW00-1.jpg"
    ],
    "description": "Marjinal Beyaz — Mutfak Karoları. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Marjinal Beyaz"
    ]
  },
  {
    "id": "qua-241-marjinal-beyaz-60X120",
    "title": "Marjinal Beyaz",
    "collection": "Marjinal Beyaz",
    "category": "Mutfak Karoları",
    "sku": "marjinal-beyaz-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015ZDRMM10X0XFABW00-1.jpg"
    ],
    "description": "Marjinal Beyaz — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Marjinal Beyaz"
    ]
  },
  {
    "id": "qua-242-marmi-statuario-30x60",
    "title": "Marmi Statuario",
    "collection": "Marmi Statuario",
    "category": "Mutfak Karoları",
    "sku": "marmi-statuario-30x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCM980X0XFABD10-1.jpg"
    ],
    "description": "Marmi Statuario — Mutfak Karoları. 30X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Marmi Statuario"
    ]
  },
  {
    "id": "qua-243-marmi-statuario-60X60",
    "title": "Marmi Statuario",
    "collection": "Marmi Statuario",
    "category": "Mutfak Karoları",
    "sku": "marmi-statuario-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCM980X0XFABD10-1.jpg"
    ],
    "description": "Marmi Statuario — Mutfak Karoları. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Marmi Statuario"
    ]
  },
  {
    "id": "qua-244-marmi-statuario-60X120",
    "title": "Marmi Statuario",
    "collection": "Marmi Statuario",
    "category": "Mutfak Karoları",
    "sku": "marmi-statuario-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCM980X0XFABD10-1.jpg"
    ],
    "description": "Marmi Statuario — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Marmi Statuario"
    ]
  },
  {
    "id": "qua-245-martins-marble-dark-60X120",
    "title": "Martins Marble Dark",
    "collection": "Martins Marble",
    "category": "Mutfak Karoları",
    "sku": "martins-marble-dark-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRMB20X0XFABD00-1.jpg"
    ],
    "description": "Martins Marble Dark — Mutfak Karoları. 60X120 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Beton",
      "Mutfak Karoları",
      "Martins Marble"
    ]
  },
  {
    "id": "qua-246-martins-marble-light-60X120",
    "title": "Martins Marble Light",
    "collection": "Martins Marble",
    "category": "Mutfak Karoları",
    "sku": "martins-marble-light-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRMB20X0XFABD00-1.jpg"
    ],
    "description": "Martins Marble Light — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Martins Marble"
    ]
  },
  {
    "id": "qua-247-matiz-3d-60x120",
    "title": "Matiz 3D",
    "collection": "Matiz",
    "category": "Mutfak Karoları",
    "sku": "matiz-3d-60x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRMT7SX0XMABW00-1.jpg"
    ],
    "description": "Matiz 3D — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "3D Yüzey",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "3D Yüzey yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "3D Yüzey",
      "Matiz"
    ]
  },
  {
    "id": "qua-248-mavi-blue-60X60",
    "title": "Mavi Blue",
    "collection": "Mavi Blue",
    "category": "İç Mekan Karoları",
    "sku": "mavi-blue-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRM840X0BMABM50-1.jpg"
    ],
    "description": "Mavi Blue — Tüm Karolar. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Tüm Karolar",
      "Mavi Blue",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-249-maya-60X120",
    "title": "Maya",
    "collection": "Maya",
    "category": "Mutfak Karoları",
    "sku": "maya-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRM090X0XCABD10-1.jpg"
    ],
    "description": "Maya — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Maya"
    ]
  },
  {
    "id": "qua-250-melden-60X120",
    "title": "Melden",
    "collection": "Melden",
    "category": "Mutfak Karoları",
    "sku": "melden-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRMS50X0XMABD10-1.jpg"
    ],
    "description": "Melden — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Melden"
    ]
  },
  {
    "id": "qua-251-mellow-gold-60X120",
    "title": "Mellow Gold",
    "collection": "Mellow Gold",
    "category": "Mutfak Karoları",
    "sku": "mellow-gold-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRZ590X0XFABD10-1.jpg"
    ],
    "description": "Mellow Gold — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Mellow Gold"
    ]
  },
  {
    "id": "qua-252-mercan-60X120",
    "title": "Mercan",
    "collection": "Mercan",
    "category": "Mutfak Karoları",
    "sku": "mercan-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRM150X0XCABD10-1.jpg"
    ],
    "description": "Mercan — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Mercan"
    ]
  },
  {
    "id": "qua-253-milano-marfil-30x60",
    "title": "Milano Marfil",
    "collection": "Milano Marfil",
    "category": "Mutfak Karoları",
    "sku": "milano-marfil-30x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCMB00X0XFABI50-1.jpg"
    ],
    "description": "Milano Marfil — Mutfak Karoları. 30X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Milano Marfil"
    ]
  },
  {
    "id": "qua-254-milano-marfil-60X60",
    "title": "Milano Marfil",
    "collection": "Milano Marfil",
    "category": "Mutfak Karoları",
    "sku": "milano-marfil-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCMB00X0XFABI50-1.jpg"
    ],
    "description": "Milano Marfil — Mutfak Karoları. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Milano Marfil"
    ]
  },
  {
    "id": "qua-255-milano-marfil-60X120",
    "title": "Milano Marfil",
    "collection": "Milano Marfil",
    "category": "Mutfak Karoları",
    "sku": "milano-marfil-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCMB00X0XFABI50-1.jpg"
    ],
    "description": "Milano Marfil — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Milano Marfil"
    ]
  },
  {
    "id": "qua-256-milano-perla-60X120",
    "title": "Milano Perla",
    "collection": "Milano Perla",
    "category": "Mutfak Karoları",
    "sku": "milano-perla-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCMB00X0XFABI50-1.jpg"
    ],
    "description": "Milano Perla — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Milano Perla"
    ]
  },
  {
    "id": "qua-257-milky-way-bianco-60x90",
    "title": "Milky Way Bianco",
    "collection": "Milky Way",
    "category": "İç Mekan Karoları",
    "sku": "milky-way-bianco-60x90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P174BDR25V0X0XGABBC0-1.jpg"
    ],
    "description": "Milky Way Bianco — Tüm Karolar. 60X90 ebatında mermer görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Mermer",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Mermer görünümlü porselen kaplama",
      "60X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X90 cm",
      "Mermer",
      "Tüm Karolar",
      "Milky Way",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-258-milky-way-graphite-60x90",
    "title": "Milky Way Graphite",
    "collection": "Milky Way Graphite",
    "category": "İç Mekan Karoları",
    "sku": "milky-way-graphite-60x90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P174BDR25V0X0XGABBC0-1.jpg"
    ],
    "description": "Milky Way Graphite — Tüm Karolar. 60X90 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X90 cm",
      "Porselen",
      "Tüm Karolar",
      "Milky Way Graphite",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-259-milky-way-gris-60x90",
    "title": "Milky Way Gris",
    "collection": "Milky Way Gris",
    "category": "İç Mekan Karoları",
    "sku": "milky-way-gris-60x90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P174BDR25V0X0XGABBC0-1.jpg"
    ],
    "description": "Milky Way Gris — Tüm Karolar. 60X90 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X90 cm",
      "Porselen",
      "Tüm Karolar",
      "Milky Way Gris",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-260-milky-way-sand-60x90",
    "title": "Milky Way Sand",
    "collection": "Milky Way",
    "category": "İç Mekan Karoları",
    "sku": "milky-way-sand-60x90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P174BDR25V0X0XGABBC0-1.jpg"
    ],
    "description": "Milky Way Sand — Tüm Karolar. 60X90 ebatında taş görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Taş",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Taş görünümlü porselen kaplama",
      "60X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X90 cm",
      "Taş",
      "Tüm Karolar",
      "Milky Way",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-261-miracle-60x120",
    "title": "Miracle",
    "collection": "Miracle",
    "category": "Mutfak Karoları",
    "sku": "miracle-60x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRMO20X0XFABD10-1.jpg"
    ],
    "description": "Miracle — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Miracle"
    ]
  },
  {
    "id": "qua-262-nervion-oro-60X120",
    "title": "Nervion Oro",
    "collection": "Nervion",
    "category": "Mutfak Karoları",
    "sku": "nervion-oro-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRV610X0XFABO10-1.jpg"
    ],
    "description": "Nervion Oro — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Nervion"
    ]
  },
  {
    "id": "qua-263-new-cora-beige-60X60",
    "title": "New Cora Beige",
    "collection": "New Cora",
    "category": "Mutfak Karoları",
    "sku": "new-cora-beige-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRCE70X0XMABBO0-1.jpg"
    ],
    "description": "New Cora Beige — Mutfak Karoları. 60X60 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Beton",
      "Mutfak Karoları",
      "New Cora"
    ]
  },
  {
    "id": "qua-264-new-eiffel-60X60",
    "title": "New Eiffel",
    "collection": "New Eiffel",
    "category": "Mutfak Karoları",
    "sku": "new-eiffel-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRE580X0XPABD10-1.jpg"
    ],
    "description": "New Eiffel — Mutfak Karoları. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "New Eiffel"
    ]
  },
  {
    "id": "qua-265-new-lagom-gra-60X60",
    "title": "New Lagom Gra",
    "collection": "New Lagom Gra",
    "category": "Mutfak Karoları",
    "sku": "new-lagom-gra-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRL840V0XMABGR0-1.jpg"
    ],
    "description": "New Lagom Gra — Mutfak Karoları. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "New Lagom Gra"
    ]
  },
  {
    "id": "qua-266-nord-stone-ice-60X60",
    "title": "Nord Stone Ice",
    "collection": "Nord Stone Ice",
    "category": "İç Mekan Karoları",
    "sku": "nord-stone-ice-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRN500X0BMABG40-1.jpg"
    ],
    "description": "Nord Stone Ice — Tüm Karolar. 60X60 ebatında taş görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Taş",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Taş görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Taş",
      "Tüm Karolar",
      "Nord Stone Ice",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-267-nord-stone-ice-61x61",
    "title": "Nord Stone Ice",
    "collection": "Nord Stone Ice",
    "category": "Mutfak Karoları",
    "sku": "nord-stone-ice-61x61",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRN500X0BMABG40-1.jpg"
    ],
    "description": "Nord Stone Ice — Mutfak Karoları. 61X61 ebatında taş görünümlü porselen karo.",
    "specs": {
      "Ebat": "61X61 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Taş",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Taş görünümlü porselen kaplama",
      "61X61 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "61X61 cm",
      "Taş",
      "Mutfak Karoları",
      "Nord Stone Ice"
    ]
  },
  {
    "id": "qua-268-nord-stone-ice-60x90",
    "title": "Nord Stone Ice",
    "collection": "Nord Stone Ice",
    "category": "İç Mekan Karoları",
    "sku": "nord-stone-ice-60x90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRN500X0BMABG40-1.jpg"
    ],
    "description": "Nord Stone Ice — Tüm Karolar. 60X90 ebatında taş görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Taş",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Taş görünümlü porselen kaplama",
      "60X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X90 cm",
      "Taş",
      "Tüm Karolar",
      "Nord Stone Ice",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-269-nordic-anthracite-30X90",
    "title": "Nordic Anthracite",
    "collection": "Nordic",
    "category": "Mutfak Karoları",
    "sku": "nordic-anthracite-30X90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRN210X0XPABG50-1.jpg"
    ],
    "description": "Nordic Anthracite — Mutfak Karoları. 30X90 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "30X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X90 cm",
      "Beton",
      "Mutfak Karoları",
      "Nordic"
    ]
  },
  {
    "id": "qua-270-nordic-grey-60X60",
    "title": "Nordic Grey",
    "collection": "Nordic",
    "category": "Mutfak Karoları",
    "sku": "nordic-grey-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRN210X0XPABG50-1.jpg"
    ],
    "description": "Nordic Grey — Mutfak Karoları. 60X60 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Beton",
      "Mutfak Karoları",
      "Nordic"
    ]
  },
  {
    "id": "qua-271-nordic-grey-60X120",
    "title": "Nordic Grey",
    "collection": "Nordic",
    "category": "Mutfak Karoları",
    "sku": "nordic-grey-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRN210X0XPABG50-1.jpg"
    ],
    "description": "Nordic Grey — Mutfak Karoları. 60X120 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Beton",
      "Mutfak Karoları",
      "Nordic"
    ]
  },
  {
    "id": "qua-272-nordic-grey-30X90",
    "title": "Nordic Grey",
    "collection": "Nordic",
    "category": "Mutfak Karoları",
    "sku": "nordic-grey-30X90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRN210X0XPABG50-1.jpg"
    ],
    "description": "Nordic Grey — Mutfak Karoları. 30X90 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "30X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X90 cm",
      "Beton",
      "Mutfak Karoları",
      "Nordic"
    ]
  },
  {
    "id": "qua-273-nordic-ivory-60X120",
    "title": "Nordic Ivory",
    "collection": "Nordic",
    "category": "Mutfak Karoları",
    "sku": "nordic-ivory-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRN210X0XPABG50-1.jpg"
    ],
    "description": "Nordic Ivory — Mutfak Karoları. 60X120 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Beton",
      "Mutfak Karoları",
      "Nordic"
    ]
  },
  {
    "id": "qua-274-nordic-ivory-30X90",
    "title": "Nordic Ivory",
    "collection": "Nordic",
    "category": "Mutfak Karoları",
    "sku": "nordic-ivory-30X90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRN210X0XPABG50-1.jpg"
    ],
    "description": "Nordic Ivory — Mutfak Karoları. 30X90 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "30X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X90 cm",
      "Beton",
      "Mutfak Karoları",
      "Nordic"
    ]
  },
  {
    "id": "qua-275-notte-blue-60X120",
    "title": "Notte Blue",
    "collection": "Notte Blue",
    "category": "Mutfak Karoları",
    "sku": "notte-blue-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRN440X0XFABM50-1.jpg"
    ],
    "description": "Notte Blue — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Notte Blue"
    ]
  },
  {
    "id": "qua-276-novada-gris-15X60",
    "title": "Novada Gris",
    "collection": "Novada Gris",
    "category": "Banyo Karoları",
    "sku": "novada-gris-15X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/G038XD0N570V0XMABG50-1.jpg"
    ],
    "description": "Novada Gris — Mutfak Karoları. 15X60 ebatında ahşap görünümlü porselen karo.",
    "specs": {
      "Ebat": "15X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Ahşap",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Ahşap görünümlü porselen kaplama",
      "15X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "15X60 cm",
      "Ahşap",
      "Mutfak Karoları",
      "Novada Gris"
    ]
  },
  {
    "id": "qua-277-novilon-gris-20x120",
    "title": "Novilon Gris",
    "collection": "Novilon Gris",
    "category": "Mutfak Karoları",
    "sku": "novilon-gris-20x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P192ZDRN610V0XMABT00-1.jpg"
    ],
    "description": "Novilon Gris — Mutfak Karoları. 20X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "20X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "20X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "20X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Novilon Gris"
    ]
  },
  {
    "id": "qua-278-novilon-pine-20x120",
    "title": "Novilon Pine",
    "collection": "Novilon Pine",
    "category": "Mutfak Karoları",
    "sku": "novilon-pine-20x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P192ZDRN610V0XMABT00-1.jpg"
    ],
    "description": "Novilon Pine — Mutfak Karoları. 20X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "20X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "20X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "20X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Novilon Pine"
    ]
  },
  {
    "id": "qua-279-novilon-red-oak-20x120",
    "title": "Novilon Red Oak",
    "collection": "Novilon Red",
    "category": "Mutfak Karoları",
    "sku": "novilon-red-oak-20x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P192ZDRN610V0XMABT00-1.jpg"
    ],
    "description": "Novilon Red Oak — Mutfak Karoları. 20X120 ebatında ahşap görünümlü porselen karo.",
    "specs": {
      "Ebat": "20X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Ahşap",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Ahşap görünümlü porselen kaplama",
      "20X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "20X120 cm",
      "Ahşap",
      "Mutfak Karoları",
      "Novilon Red"
    ]
  },
  {
    "id": "qua-280-novilon-taupe-20x120",
    "title": "Novilon Taupe",
    "collection": "Novilon Taupe",
    "category": "Mutfak Karoları",
    "sku": "novilon-taupe-20x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P192ZDRN610V0XMABT00-1.jpg"
    ],
    "description": "Novilon Taupe — Mutfak Karoları. 20X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "20X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "20X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "20X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Novilon Taupe"
    ]
  },
  {
    "id": "qua-281-ocean-blue-30x60",
    "title": "Ocean Blue",
    "collection": "Ocean Blue",
    "category": "Mutfak Karoları",
    "sku": "ocean-blue-30x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCQ470X0XFABM50-1.jpg"
    ],
    "description": "Ocean Blue — Mutfak Karoları. 30X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Ocean Blue"
    ]
  },
  {
    "id": "qua-282-ocean-blue-60X60",
    "title": "Ocean Blue",
    "collection": "Ocean Blue",
    "category": "Mutfak Karoları",
    "sku": "ocean-blue-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCQ470X0XFABM50-1.jpg"
    ],
    "description": "Ocean Blue — Mutfak Karoları. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Ocean Blue"
    ]
  },
  {
    "id": "qua-283-octavia-mocha-3d-60x120",
    "title": "Octavia Mocha 3D",
    "collection": "Octavia Mocha",
    "category": "Mutfak Karoları",
    "sku": "octavia-mocha-3d-60x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRQ56SX0XMABK30-1.jpg"
    ],
    "description": "Octavia Mocha 3D — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "3D Yüzey",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "3D Yüzey yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "3D Yüzey",
      "Octavia Mocha"
    ]
  },
  {
    "id": "qua-284-octavia-taupe-3d-60x120",
    "title": "Octavia Taupe 3D",
    "collection": "Octavia Taupe",
    "category": "Mutfak Karoları",
    "sku": "octavia-taupe-3d-60x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRQ56SX0XMABK30-1.jpg"
    ],
    "description": "Octavia Taupe 3D — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "3D Yüzey",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "3D Yüzey yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "3D Yüzey",
      "Octavia Taupe"
    ]
  },
  {
    "id": "qua-285-octavia-white-3d-60x120",
    "title": "Octavia White 3D",
    "collection": "Octavia White",
    "category": "Mutfak Karoları",
    "sku": "octavia-white-3d-60x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRQ56SX0XMABK30-1.jpg"
    ],
    "description": "Octavia White 3D — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "3D Yüzey",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "3D Yüzey yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "3D Yüzey",
      "Octavia White"
    ]
  },
  {
    "id": "qua-286-olina-grey-30X90",
    "title": "Olina Grey",
    "collection": "Olina",
    "category": "Mutfak Karoları",
    "sku": "olina-grey-30X90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/W188XDRQ46040XMABG50-1.jpg"
    ],
    "description": "Olina Grey — Mutfak Karoları. 30X90 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X90 cm",
      "Porselen",
      "Mutfak Karoları",
      "Olina"
    ]
  },
  {
    "id": "qua-287-olina-grey-cube-dekofon-30X90",
    "title": "Olina Grey Cube Dekofon",
    "collection": "Olina Grey Cube Dekofon",
    "category": "Mutfak Karoları",
    "sku": "olina-grey-cube-dekofon-30X90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/W188XDRQ46040XMABG50-1.jpg"
    ],
    "description": "Olina Grey Cube Dekofon — Mutfak Karoları. 30X90 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X90 cm",
      "Yüzey": "3D Yüzey",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X90 cm ebat",
      "3D Yüzey yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X90 cm",
      "Porselen",
      "Mutfak Karoları",
      "3D Yüzey",
      "Olina Grey Cube Dekofon"
    ]
  },
  {
    "id": "qua-288-olina-grey-grey-dekofon-30X90",
    "title": "Olina Grey Grey Dekofon",
    "collection": "Olina Grey Grey Dekofon",
    "category": "Mutfak Karoları",
    "sku": "olina-grey-grey-dekofon-30X90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/W188XDRQ46040XMABG50-1.jpg"
    ],
    "description": "Olina Grey Grey Dekofon — Mutfak Karoları. 30X90 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X90 cm",
      "Yüzey": "3D Yüzey",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X90 cm ebat",
      "3D Yüzey yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X90 cm",
      "Porselen",
      "Mutfak Karoları",
      "3D Yüzey",
      "Olina Grey Grey Dekofon"
    ]
  },
  {
    "id": "qua-289-olina-white-30X90",
    "title": "Olina White",
    "collection": "Olina",
    "category": "Mutfak Karoları",
    "sku": "olina-white-30X90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/W188XDRQ46040XMABG50-1.jpg"
    ],
    "description": "Olina White — Mutfak Karoları. 30X90 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X90 cm",
      "Porselen",
      "Mutfak Karoları",
      "Olina"
    ]
  },
  {
    "id": "qua-290-olina-white-cube-dekofon-30X90",
    "title": "Olina White Cube Dekofon",
    "collection": "Olina White Cube Dekofon",
    "category": "Mutfak Karoları",
    "sku": "olina-white-cube-dekofon-30X90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/W188XDRQ46040XMABG50-1.jpg"
    ],
    "description": "Olina White Cube Dekofon — Mutfak Karoları. 30X90 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X90 cm",
      "Yüzey": "3D Yüzey",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X90 cm ebat",
      "3D Yüzey yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X90 cm",
      "Porselen",
      "Mutfak Karoları",
      "3D Yüzey",
      "Olina White Cube Dekofon"
    ]
  },
  {
    "id": "qua-291-olina-white-dekofon-30X90",
    "title": "Olina White Dekofon",
    "collection": "Olina White Dekofon",
    "category": "Mutfak Karoları",
    "sku": "olina-white-dekofon-30X90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/W188XDRQ46040XMABG50-1.jpg"
    ],
    "description": "Olina White Dekofon — Mutfak Karoları. 30X90 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X90 cm",
      "Yüzey": "3D Yüzey",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X90 cm ebat",
      "3D Yüzey yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X90 cm",
      "Porselen",
      "Mutfak Karoları",
      "3D Yüzey",
      "Olina White Dekofon"
    ]
  },
  {
    "id": "qua-292-otto-grey-60X120",
    "title": "Otto Grey",
    "collection": "Otto",
    "category": "Mutfak Karoları",
    "sku": "otto-grey-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDR12V0X0XFABD10-1.jpg"
    ],
    "description": "Otto Grey — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Otto"
    ]
  },
  {
    "id": "qua-293-pearl-60X120",
    "title": "Pearl",
    "collection": "Pearl",
    "category": "Mutfak Karoları",
    "sku": "pearl-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRP700X0XFABW00-1.jpg"
    ],
    "description": "Pearl — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Pearl"
    ]
  },
  {
    "id": "qua-294-pera-wood-dark-60X120",
    "title": "Pera Wood Dark",
    "collection": "Pera Wood",
    "category": "Mutfak Karoları",
    "sku": "pera-wood-dark-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRPC20X0XGABD00-1.jpg"
    ],
    "description": "Pera Wood Dark — Mutfak Karoları. 60X120 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Beton",
      "Mutfak Karoları",
      "Pera Wood"
    ]
  },
  {
    "id": "qua-295-pera-wood-light-60X120",
    "title": "Pera Wood Light",
    "collection": "Pera Wood",
    "category": "Mutfak Karoları",
    "sku": "pera-wood-light-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRPC20X0XGABD00-1.jpg"
    ],
    "description": "Pera Wood Light — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Pera Wood"
    ]
  },
  {
    "id": "qua-296-pierre-blue-60X60",
    "title": "Pierre Blue",
    "collection": "Pierre Blue",
    "category": "İç Mekan Karoları",
    "sku": "pierre-blue-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRP940X0BGABDB0-1.jpg"
    ],
    "description": "Pierre Blue — Tüm Karolar. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Tüm Karolar",
      "Pierre Blue",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-297-pierre-dark-blue-60X60",
    "title": "Pierre Dark Blue",
    "collection": "Pierre Dark Blue",
    "category": "İç Mekan Karoları",
    "sku": "pierre-dark-blue-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRP940X0BGABDB0-1.jpg"
    ],
    "description": "Pierre Dark Blue — Tüm Karolar. 60X60 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Beton",
      "Tüm Karolar",
      "Pierre Dark Blue",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-298-pierre-noir-60X60",
    "title": "Pierre Noir",
    "collection": "Pierre Noir",
    "category": "İç Mekan Karoları",
    "sku": "pierre-noir-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRP940X0BGABDB0-1.jpg"
    ],
    "description": "Pierre Noir — Tüm Karolar. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Tüm Karolar",
      "Pierre Noir",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-299-pietra-anthracite-60X60",
    "title": "Pietra Anthracite",
    "collection": "Pietra",
    "category": "İç Mekan Karoları",
    "sku": "pietra-anthracite-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRP130X0AMABAT0-1.jpg"
    ],
    "description": "Pietra Anthracite — Tüm Karolar. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Tüm Karolar",
      "Pietra",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-300-pietra-grey-60X60",
    "title": "Pietra Grey",
    "collection": "Pietra",
    "category": "İç Mekan Karoları",
    "sku": "pietra-grey-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRP130X0AMABAT0-1.jpg"
    ],
    "description": "Pietra Grey — Tüm Karolar. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Tüm Karolar",
      "Pietra",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-301-pole-60X120",
    "title": "Pole",
    "collection": "Pole",
    "category": "Mutfak Karoları",
    "sku": "pole-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRPA60X0XFABD10-1.jpg"
    ],
    "description": "Pole — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Pole"
    ]
  },
  {
    "id": "qua-302-premium-teak-20x120",
    "title": "Premium Teak",
    "collection": "Premium",
    "category": "Mutfak Karoları",
    "sku": "premium-teak-20x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P192ZDRPC10V0XMABE30-1.jpg"
    ],
    "description": "Premium Teak — Mutfak Karoları. 20X120 ebatında ahşap görünümlü porselen karo.",
    "specs": {
      "Ebat": "20X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Ahşap",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Ahşap görünümlü porselen kaplama",
      "20X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "20X120 cm",
      "Ahşap",
      "Mutfak Karoları",
      "Premium"
    ]
  },
  {
    "id": "qua-303-prestige-carmel-20x120",
    "title": "Prestige Carmel",
    "collection": "Prestige Carmel",
    "category": "Mutfak Karoları",
    "sku": "prestige-carmel-20x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P192ZDRW600X0XMABBR0-1.jpg"
    ],
    "description": "Prestige Carmel — Mutfak Karoları. 20X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "20X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "20X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "20X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Prestige Carmel"
    ]
  },
  {
    "id": "qua-304-prestige-miele-20x120",
    "title": "Prestige Miele",
    "collection": "Prestige Miele",
    "category": "Mutfak Karoları",
    "sku": "prestige-miele-20x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P192ZDRW600X0XMABBR0-1.jpg"
    ],
    "description": "Prestige Miele — Mutfak Karoları. 20X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "20X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "20X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "20X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Prestige Miele"
    ]
  },
  {
    "id": "qua-305-prestige-noce-20x120",
    "title": "Prestige Noce",
    "collection": "Prestige Noce",
    "category": "Mutfak Karoları",
    "sku": "prestige-noce-20x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P192ZDRW600X0XMABBR0-1.jpg"
    ],
    "description": "Prestige Noce — Mutfak Karoları. 20X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "20X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "20X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "20X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Prestige Noce"
    ]
  },
  {
    "id": "qua-306-prestige-walnut-20x120",
    "title": "Prestige Walnut",
    "collection": "Prestige",
    "category": "Mutfak Karoları",
    "sku": "prestige-walnut-20x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P192ZDRW600X0XMABBR0-1.jpg"
    ],
    "description": "Prestige Walnut — Mutfak Karoları. 20X120 ebatında ahşap görünümlü porselen karo.",
    "specs": {
      "Ebat": "20X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Ahşap",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Ahşap görünümlü porselen kaplama",
      "20X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "20X120 cm",
      "Ahşap",
      "Mutfak Karoları",
      "Prestige"
    ]
  },
  {
    "id": "qua-307-pulpis-anthracite-30X90",
    "title": "Pulpis Anthracite",
    "collection": "Pulpis",
    "category": "Mutfak Karoları",
    "sku": "pulpis-anthracite-30X90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRP620X0XPABG50-1.jpg"
    ],
    "description": "Pulpis Anthracite — Mutfak Karoları. 30X90 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X90 cm",
      "Porselen",
      "Mutfak Karoları",
      "Pulpis"
    ]
  },
  {
    "id": "qua-308-pulpis-gey-60X120",
    "title": "Pulpis Gey",
    "collection": "Pulpis Gey",
    "category": "Mutfak Karoları",
    "sku": "pulpis-gey-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRP620X0XPABG50-1.jpg"
    ],
    "description": "Pulpis Gey — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Pulpis Gey"
    ]
  },
  {
    "id": "qua-309-pulpis-grey-60X60",
    "title": "Pulpis Grey",
    "collection": "Pulpis",
    "category": "Mutfak Karoları",
    "sku": "pulpis-grey-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRP620X0XPABG50-1.jpg"
    ],
    "description": "Pulpis Grey — Mutfak Karoları. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Pulpis"
    ]
  },
  {
    "id": "qua-310-pulpis-grey-60X120",
    "title": "Pulpis Grey",
    "collection": "Pulpis",
    "category": "Mutfak Karoları",
    "sku": "pulpis-grey-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRP620X0XPABG50-1.jpg"
    ],
    "description": "Pulpis Grey — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Pulpis"
    ]
  },
  {
    "id": "qua-311-pulpis-grey-100x100",
    "title": "Pulpis Grey",
    "collection": "Pulpis",
    "category": "Mutfak Karoları",
    "sku": "pulpis-grey-100x100",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRP620X0XPABG50-1.jpg"
    ],
    "description": "Pulpis Grey — Mutfak Karoları. 100X100 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "100X100 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "100X100 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "100X100 cm",
      "Porselen",
      "Mutfak Karoları",
      "Pulpis"
    ]
  },
  {
    "id": "qua-312-pulpis-grey-30X90",
    "title": "Pulpis Grey",
    "collection": "Pulpis",
    "category": "Mutfak Karoları",
    "sku": "pulpis-grey-30X90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRP620X0XPABG50-1.jpg"
    ],
    "description": "Pulpis Grey — Mutfak Karoları. 30X90 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X90 cm",
      "Porselen",
      "Mutfak Karoları",
      "Pulpis"
    ]
  },
  {
    "id": "qua-313-pulpis-grey-dekofon-30X90",
    "title": "Pulpis Grey Dekofon",
    "collection": "Pulpis Grey Dekofon",
    "category": "Mutfak Karoları",
    "sku": "pulpis-grey-dekofon-30X90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRP620X0XPABG50-1.jpg"
    ],
    "description": "Pulpis Grey Dekofon — Mutfak Karoları. 30X90 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X90 cm",
      "Yüzey": "3D Yüzey",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X90 cm ebat",
      "3D Yüzey yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X90 cm",
      "Porselen",
      "Mutfak Karoları",
      "3D Yüzey",
      "Pulpis Grey Dekofon"
    ]
  },
  {
    "id": "qua-314-pulpis-nero-60X120",
    "title": "Pulpis Nero",
    "collection": "Pulpis",
    "category": "Mutfak Karoları",
    "sku": "pulpis-nero-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRP620X0XPABG50-1.jpg"
    ],
    "description": "Pulpis Nero — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Pulpis"
    ]
  },
  {
    "id": "qua-315-pulpis-sand-60X120",
    "title": "Pulpis Sand",
    "collection": "Pulpis",
    "category": "Mutfak Karoları",
    "sku": "pulpis-sand-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRP620X0XPABG50-1.jpg"
    ],
    "description": "Pulpis Sand — Mutfak Karoları. 60X120 ebatında taş görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Taş",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Taş görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Taş",
      "Mutfak Karoları",
      "Pulpis"
    ]
  },
  {
    "id": "qua-316-qua-calacatta-60X60",
    "title": "Qua Calacatta",
    "collection": "Qua Calacatta",
    "category": "Mutfak Karoları",
    "sku": "qua-calacatta-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015ZDRC630X0XFABW50-1.jpg"
    ],
    "description": "Qua Calacatta — Mutfak Karoları. 60X60 ebatında mermer görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Mermer",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Mermer görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Mermer",
      "Mutfak Karoları",
      "Qua Calacatta"
    ]
  },
  {
    "id": "qua-317-rasa-beige-60X60",
    "title": "Rasa Beige",
    "collection": "Rasa",
    "category": "İç Mekan Karoları",
    "sku": "rasa-beige-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRR250V0BGABBO0-1.jpg"
    ],
    "description": "Rasa Beige — Tüm Karolar. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Tüm Karolar",
      "Rasa",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-318-rasa-beige-60X120",
    "title": "Rasa Beige",
    "collection": "Rasa",
    "category": "İç Mekan Karoları",
    "sku": "rasa-beige-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRR250V0BGABBO0-1.jpg"
    ],
    "description": "Rasa Beige — Tüm Karolar. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Tüm Karolar",
      "Rasa",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-319-rasa-beige-60x90",
    "title": "Rasa Beige",
    "collection": "Rasa",
    "category": "İç Mekan Karoları",
    "sku": "rasa-beige-60x90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRR250V0BGABBO0-1.jpg"
    ],
    "description": "Rasa Beige — Tüm Karolar. 60X90 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X90 cm",
      "Porselen",
      "Tüm Karolar",
      "Rasa",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-320-rasa-beige-80x80",
    "title": "Rasa Beige",
    "collection": "Rasa",
    "category": "İç Mekan Karoları",
    "sku": "rasa-beige-80x80",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRR250V0BGABBO0-1.jpg"
    ],
    "description": "Rasa Beige — Tüm Karolar. 80X80 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "80X80 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "80X80 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "80X80 cm",
      "Porselen",
      "Tüm Karolar",
      "Rasa",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-321-rasa-grey-60X60",
    "title": "Rasa Grey",
    "collection": "Rasa",
    "category": "İç Mekan Karoları",
    "sku": "rasa-grey-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRR250V0BGABBO0-1.jpg"
    ],
    "description": "Rasa Grey — Tüm Karolar. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Tüm Karolar",
      "Rasa",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-322-rasa-grey-60X120",
    "title": "Rasa Grey",
    "collection": "Rasa",
    "category": "İç Mekan Karoları",
    "sku": "rasa-grey-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRR250V0BGABBO0-1.jpg"
    ],
    "description": "Rasa Grey — Tüm Karolar. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Tüm Karolar",
      "Rasa",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-323-rasa-grey-60x90",
    "title": "Rasa Grey",
    "collection": "Rasa",
    "category": "İç Mekan Karoları",
    "sku": "rasa-grey-60x90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRR250V0BGABBO0-1.jpg"
    ],
    "description": "Rasa Grey — Tüm Karolar. 60X90 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X90 cm",
      "Porselen",
      "Tüm Karolar",
      "Rasa",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-324-rasa-grey-80x80",
    "title": "Rasa Grey",
    "collection": "Rasa",
    "category": "İç Mekan Karoları",
    "sku": "rasa-grey-80x80",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRR250V0BGABBO0-1.jpg"
    ],
    "description": "Rasa Grey — Tüm Karolar. 80X80 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "80X80 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "80X80 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "80X80 cm",
      "Porselen",
      "Tüm Karolar",
      "Rasa",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-325-rasa-nero-60X60",
    "title": "Rasa Nero",
    "collection": "Rasa",
    "category": "İç Mekan Karoları",
    "sku": "rasa-nero-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRR250V0BGABBO0-1.jpg"
    ],
    "description": "Rasa Nero — Tüm Karolar. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Tüm Karolar",
      "Rasa",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-326-rasa-nero-60X120",
    "title": "Rasa Nero",
    "collection": "Rasa",
    "category": "İç Mekan Karoları",
    "sku": "rasa-nero-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRR250V0BGABBO0-1.jpg"
    ],
    "description": "Rasa Nero — Tüm Karolar. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Tüm Karolar",
      "Rasa",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-327-rasa-nero-60x90",
    "title": "Rasa Nero",
    "collection": "Rasa",
    "category": "İç Mekan Karoları",
    "sku": "rasa-nero-60x90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRR250V0BGABBO0-1.jpg"
    ],
    "description": "Rasa Nero — Tüm Karolar. 60X90 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X90 cm",
      "Porselen",
      "Tüm Karolar",
      "Rasa",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-328-rasa-white-60X60",
    "title": "Rasa White",
    "collection": "Rasa",
    "category": "İç Mekan Karoları",
    "sku": "rasa-white-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRR250V0BGABBO0-1.jpg"
    ],
    "description": "Rasa White — Tüm Karolar. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Tüm Karolar",
      "Rasa",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-329-rasa-white-60x90",
    "title": "Rasa White",
    "collection": "Rasa",
    "category": "İç Mekan Karoları",
    "sku": "rasa-white-60x90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRR250V0BGABBO0-1.jpg"
    ],
    "description": "Rasa White — Tüm Karolar. 60X90 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X90 cm",
      "Porselen",
      "Tüm Karolar",
      "Rasa",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-330-retro-stone-60x90",
    "title": "Retro Stone",
    "collection": "Retro",
    "category": "İç Mekan Karoları",
    "sku": "retro-stone-60x90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P174BDRR410X0XMABD10-1.jpg"
    ],
    "description": "Retro Stone — Tüm Karolar. 60X90 ebatında taş görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Taş",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Taş görünümlü porselen kaplama",
      "60X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X90 cm",
      "Taş",
      "Tüm Karolar",
      "Retro",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-331-roca-beige-60x90",
    "title": "Roca Beige",
    "collection": "Roca",
    "category": "İç Mekan Karoları",
    "sku": "roca-beige-60x90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P174BDRR460X0XGABBO0-1.jpg"
    ],
    "description": "Roca Beige — Tüm Karolar. 60X90 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X90 cm",
      "Porselen",
      "Tüm Karolar",
      "Roca",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-332-roca-grey-60x90",
    "title": "Roca Grey",
    "collection": "Roca",
    "category": "İç Mekan Karoları",
    "sku": "roca-grey-60x90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P174BDRR460X0XGABBO0-1.jpg"
    ],
    "description": "Roca Grey — Tüm Karolar. 60X90 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X90 cm",
      "Porselen",
      "Tüm Karolar",
      "Roca",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-333-roca-white-60x90",
    "title": "Roca White",
    "collection": "Roca",
    "category": "İç Mekan Karoları",
    "sku": "roca-white-60x90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P174BDRR460X0XGABBO0-1.jpg"
    ],
    "description": "Roca White — Tüm Karolar. 60X90 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X90 cm",
      "Porselen",
      "Tüm Karolar",
      "Roca",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-334-royal-travertine-60X120",
    "title": "Royal Travertine",
    "collection": "Royal Travertine",
    "category": "Mutfak Karoları",
    "sku": "royal-travertine-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDR55V0X0XKABD10-1.jpg"
    ],
    "description": "Royal Travertine — Mutfak Karoları. 60X120 ebatında travertin görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Travertin",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Travertin görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Travertin",
      "Mutfak Karoları",
      "Royal Travertine"
    ]
  },
  {
    "id": "qua-335-shanti-60X60",
    "title": "Shanti",
    "collection": "Shanti",
    "category": "Mutfak Karoları",
    "sku": "shanti-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRSC80X0XPABW50-1.jpg"
    ],
    "description": "Shanti — Mutfak Karoları. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Shanti"
    ]
  },
  {
    "id": "qua-336-shanti-60X120",
    "title": "Shanti",
    "collection": "Shanti",
    "category": "Mutfak Karoları",
    "sku": "shanti-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRSC80X0XPABW50-1.jpg"
    ],
    "description": "Shanti — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Shanti"
    ]
  },
  {
    "id": "qua-337-shanti-30X90",
    "title": "Shanti",
    "collection": "Shanti",
    "category": "Mutfak Karoları",
    "sku": "shanti-30X90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRSC80X0XPABW50-1.jpg"
    ],
    "description": "Shanti — Mutfak Karoları. 30X90 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X90 cm",
      "Porselen",
      "Mutfak Karoları",
      "Shanti"
    ]
  },
  {
    "id": "qua-338-shanti-anthracite-30x60",
    "title": "Shanti Anthracite",
    "collection": "Shanti",
    "category": "Mutfak Karoları",
    "sku": "shanti-anthracite-30x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRSC80X0XPABW50-1.jpg"
    ],
    "description": "Shanti Anthracite — Mutfak Karoları. 30X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Shanti"
    ]
  },
  {
    "id": "qua-339-shanti-dekofon-30x60",
    "title": "Shanti Dekofon",
    "collection": "Shanti Dekofon",
    "category": "Mutfak Karoları",
    "sku": "shanti-dekofon-30x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRSC80X0XPABW50-1.jpg"
    ],
    "description": "Shanti Dekofon — Mutfak Karoları. 30X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X60 cm",
      "Yüzey": "3D Yüzey",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X60 cm ebat",
      "3D Yüzey yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "3D Yüzey",
      "Shanti Dekofon"
    ]
  },
  {
    "id": "qua-340-silvana-grey-60X60",
    "title": "Silvana Grey",
    "collection": "Silvana",
    "category": "Mutfak Karoları",
    "sku": "silvana-grey-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRSF70X0XMABAT0-1.jpg"
    ],
    "description": "Silvana Grey — Mutfak Karoları. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Silvana"
    ]
  },
  {
    "id": "qua-341-silvana-new-anthracite-60X60",
    "title": "Silvana New Anthracite",
    "collection": "Silvana New",
    "category": "Mutfak Karoları",
    "sku": "silvana-new-anthracite-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRSF70X0XMABAT0-1.jpg"
    ],
    "description": "Silvana New Anthracite — Mutfak Karoları. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Silvana New"
    ]
  },
  {
    "id": "qua-342-silvana-new-grey-60x60",
    "title": "Silvana New Grey",
    "collection": "Silvana New",
    "category": "Mutfak Karoları",
    "sku": "silvana-new-grey-60x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRSF70X0XMABAT0-1.jpg"
    ],
    "description": "Silvana New Grey — Mutfak Karoları. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Silvana New"
    ]
  },
  {
    "id": "qua-343-silver-travertine-60X60",
    "title": "Silver Travertine",
    "collection": "Silver Travertine",
    "category": "İç Mekan Karoları",
    "sku": "silver-travertine-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRSD80V0BMABSL0-1.jpg"
    ],
    "description": "Silver Travertine — Tüm Karolar. 60X60 ebatında travertin görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Travertin",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Travertin görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Travertin",
      "Tüm Karolar",
      "Silver Travertine",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-344-silver-wood-grigio-30x120",
    "title": "Silver Wood Grigio",
    "collection": "Silver Wood",
    "category": "İç Mekan Karoları",
    "sku": "silver-wood-grigio-30x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P171BDRSB50V0BMABB50-1.jpg"
    ],
    "description": "Silver Wood Grigio — Tüm Karolar. 30X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X120 cm",
      "Porselen",
      "Tüm Karolar",
      "Silver Wood",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-345-silver-wood-miele-30x120",
    "title": "Silver Wood Miele",
    "collection": "Silver Wood Miele",
    "category": "İç Mekan Karoları",
    "sku": "silver-wood-miele-30x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P171BDRSB50V0BMABB50-1.jpg"
    ],
    "description": "Silver Wood Miele — Tüm Karolar. 30X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X120 cm",
      "Porselen",
      "Tüm Karolar",
      "Silver Wood Miele",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-346-sombra-black-60X60",
    "title": "Sombra Black",
    "collection": "Sombra",
    "category": "Mutfak Karoları",
    "sku": "sombra-black-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015ZDRS990X0XFABS00-1.jpg"
    ],
    "description": "Sombra Black — Mutfak Karoları. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Sombra"
    ]
  },
  {
    "id": "qua-347-sombra-black-60X120",
    "title": "Sombra Black",
    "collection": "Sombra",
    "category": "Mutfak Karoları",
    "sku": "sombra-black-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015ZDRS990X0XFABS00-1.jpg"
    ],
    "description": "Sombra Black — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Sombra"
    ]
  },
  {
    "id": "qua-348-sound-grey-60X60",
    "title": "Sound Grey",
    "collection": "Sound",
    "category": "Mutfak Karoları",
    "sku": "sound-grey-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRS920X0XPABG50-1.jpg"
    ],
    "description": "Sound Grey — Mutfak Karoları. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Sound"
    ]
  },
  {
    "id": "qua-349-sound-grey-30X90",
    "title": "Sound Grey",
    "collection": "Sound",
    "category": "Mutfak Karoları",
    "sku": "sound-grey-30X90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRS920X0XPABG50-1.jpg"
    ],
    "description": "Sound Grey — Mutfak Karoları. 30X90 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X90 cm",
      "Porselen",
      "Mutfak Karoları",
      "Sound"
    ]
  },
  {
    "id": "qua-350-sound-white-60X60",
    "title": "Sound White",
    "collection": "Sound",
    "category": "Mutfak Karoları",
    "sku": "sound-white-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRS920X0XPABG50-1.jpg"
    ],
    "description": "Sound White — Mutfak Karoları. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Sound"
    ]
  },
  {
    "id": "qua-351-sound-white-30X90",
    "title": "Sound White",
    "collection": "Sound",
    "category": "Mutfak Karoları",
    "sku": "sound-white-30X90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRS920X0XPABG50-1.jpg"
    ],
    "description": "Sound White — Mutfak Karoları. 30X90 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X90 cm",
      "Porselen",
      "Mutfak Karoları",
      "Sound"
    ]
  },
  {
    "id": "qua-352-space-anthracite-30x60",
    "title": "Space Anthracite",
    "collection": "Space",
    "category": "Mutfak Karoları",
    "sku": "space-anthracite-30x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010XDCS860X0XFABF50-1.jpg"
    ],
    "description": "Space Anthracite — Mutfak Karoları. 30X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Space"
    ]
  },
  {
    "id": "qua-353-space-anthracite-60X60",
    "title": "Space Anthracite",
    "collection": "Space",
    "category": "Mutfak Karoları",
    "sku": "space-anthracite-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010XDCS860X0XFABF50-1.jpg"
    ],
    "description": "Space Anthracite — Mutfak Karoları. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Space"
    ]
  },
  {
    "id": "qua-354-space-anthracite-60X120",
    "title": "Space Anthracite",
    "collection": "Space",
    "category": "Mutfak Karoları",
    "sku": "space-anthracite-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010XDCS860X0XFABF50-1.jpg"
    ],
    "description": "Space Anthracite — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Space"
    ]
  },
  {
    "id": "qua-355-space-grey-60X60",
    "title": "Space Grey",
    "collection": "Space",
    "category": "Mutfak Karoları",
    "sku": "space-grey-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010XDCS860X0XFABF50-1.jpg"
    ],
    "description": "Space Grey — Mutfak Karoları. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Space"
    ]
  },
  {
    "id": "qua-356-space-grey-60X120",
    "title": "Space Grey",
    "collection": "Space",
    "category": "Mutfak Karoları",
    "sku": "space-grey-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010XDCS860X0XFABF50-1.jpg"
    ],
    "description": "Space Grey — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Space"
    ]
  },
  {
    "id": "qua-357-space-grey-30x60",
    "title": "Space Grey",
    "collection": "Space",
    "category": "Mutfak Karoları",
    "sku": "space-grey-30x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010XDCS860X0XFABF50-1.jpg"
    ],
    "description": "Space Grey — Mutfak Karoları. 30X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Space"
    ]
  },
  {
    "id": "qua-358-space-grey-dekofon-30x60",
    "title": "Space Grey Dekofon",
    "collection": "Space Grey Dekofon",
    "category": "Mutfak Karoları",
    "sku": "space-grey-dekofon-30x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010XDCS860X0XFABF50-1.jpg"
    ],
    "description": "Space Grey Dekofon — Mutfak Karoları. 30X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X60 cm",
      "Yüzey": "3D Yüzey",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X60 cm ebat",
      "3D Yüzey yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "3D Yüzey",
      "Space Grey Dekofon"
    ]
  },
  {
    "id": "qua-359-star-graphite-60X60",
    "title": "Star Graphite",
    "collection": "Star Graphite",
    "category": "İç Mekan Karoları",
    "sku": "star-graphite-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCS810X0AMABF40-1.jpg"
    ],
    "description": "Star Graphite — Tüm Karolar. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Tüm Karolar",
      "Star Graphite",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-360-stark-graphite-30x60",
    "title": "Stark Graphite",
    "collection": "Stark Graphite",
    "category": "Mutfak Karoları",
    "sku": "stark-graphite-30x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCS810X0AMABF40-1.jpg"
    ],
    "description": "Stark Graphite — Mutfak Karoları. 30X60 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "30X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X60 cm",
      "Beton",
      "Mutfak Karoları",
      "Stark Graphite"
    ]
  },
  {
    "id": "qua-361-stark-graphite-60X60",
    "title": "Stark Graphite",
    "collection": "Stark Graphite",
    "category": "Mutfak Karoları",
    "sku": "stark-graphite-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCS810X0AMABF40-1.jpg"
    ],
    "description": "Stark Graphite — Mutfak Karoları. 60X60 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Beton",
      "Mutfak Karoları",
      "Stark Graphite"
    ]
  },
  {
    "id": "qua-362-stark-graphite-60X120",
    "title": "Stark Graphite",
    "collection": "Stark Graphite",
    "category": "2 cm Bahçe Karoları",
    "sku": "stark-graphite-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCS810X0AMABF40-1.jpg"
    ],
    "description": "Stark Graphite — Tüm Karolar. 60X120 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "Dış Mekan / Bahçe / Teras",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Beton",
      "Tüm Karolar",
      "Stark Graphite",
      "2 cm Bahçe Karoları"
    ]
  },
  {
    "id": "qua-363-stark-graphite-80x80",
    "title": "Stark Graphıte",
    "collection": "Stark Graphıte",
    "category": "2 cm Bahçe Karoları",
    "sku": "stark-graphite-80x80",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCS810X0AMABF40-1.jpg"
    ],
    "description": "Stark Graphıte — Tüm Karolar. 80X80 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "80X80 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "Dış Mekan / Bahçe / Teras",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "80X80 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "80X80 cm",
      "Beton",
      "Tüm Karolar",
      "Stark Graphıte",
      "2 cm Bahçe Karoları"
    ]
  },
  {
    "id": "qua-364-stark-grey-30x60",
    "title": "Stark Grey",
    "collection": "Stark",
    "category": "Mutfak Karoları",
    "sku": "stark-grey-30x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCS810X0AMABF40-1.jpg"
    ],
    "description": "Stark Grey — Mutfak Karoları. 30X60 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "30X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X60 cm",
      "Beton",
      "Mutfak Karoları",
      "Stark"
    ]
  },
  {
    "id": "qua-365-stark-grey-60X60",
    "title": "Stark Grey",
    "collection": "Stark",
    "category": "2 cm Bahçe Karoları",
    "sku": "stark-grey-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCS810X0AMABF40-1.jpg"
    ],
    "description": "Stark Grey — Tüm Karolar. 60X60 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "Dış Mekan / Bahçe / Teras",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Beton",
      "Tüm Karolar",
      "Stark",
      "2 cm Bahçe Karoları"
    ]
  },
  {
    "id": "qua-366-stark-grey-60X120",
    "title": "Stark Grey",
    "collection": "Stark",
    "category": "2 cm Bahçe Karoları",
    "sku": "stark-grey-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCS810X0AMABF40-1.jpg"
    ],
    "description": "Stark Grey — Tüm Karolar. 60X120 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "Dış Mekan / Bahçe / Teras",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Beton",
      "Tüm Karolar",
      "Stark",
      "2 cm Bahçe Karoları"
    ]
  },
  {
    "id": "qua-367-stark-grey-80x80",
    "title": "Stark Grey",
    "collection": "Stark",
    "category": "2 cm Bahçe Karoları",
    "sku": "stark-grey-80x80",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCS810X0AMABF40-1.jpg"
    ],
    "description": "Stark Grey — Tüm Karolar. 80X80 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "80X80 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "Dış Mekan / Bahçe / Teras",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "80X80 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "80X80 cm",
      "Beton",
      "Tüm Karolar",
      "Stark",
      "2 cm Bahçe Karoları"
    ]
  },
  {
    "id": "qua-368-stark-grey-100x100",
    "title": "Stark Grey",
    "collection": "Stark",
    "category": "Mutfak Karoları",
    "sku": "stark-grey-100x100",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCS810X0AMABF40-1.jpg"
    ],
    "description": "Stark Grey — Mutfak Karoları. 100X100 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "100X100 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "100X100 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "100X100 cm",
      "Beton",
      "Mutfak Karoları",
      "Stark"
    ]
  },
  {
    "id": "qua-369-stark-smoke-30x60",
    "title": "Stark Smoke",
    "collection": "Stark Smoke",
    "category": "Mutfak Karoları",
    "sku": "stark-smoke-30x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCS810X0AMABF40-1.jpg"
    ],
    "description": "Stark Smoke — Mutfak Karoları. 30X60 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "30X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X60 cm",
      "Beton",
      "Mutfak Karoları",
      "Stark Smoke"
    ]
  },
  {
    "id": "qua-370-stark-smoke-60X60",
    "title": "Stark Smoke",
    "collection": "Stark Smoke",
    "category": "2 cm Bahçe Karoları",
    "sku": "stark-smoke-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCS810X0AMABF40-1.jpg"
    ],
    "description": "Stark Smoke — Tüm Karolar. 60X60 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "Dış Mekan / Bahçe / Teras",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Beton",
      "Tüm Karolar",
      "Stark Smoke",
      "2 cm Bahçe Karoları"
    ]
  },
  {
    "id": "qua-371-stark-smoke-60X120",
    "title": "Stark Smoke",
    "collection": "Stark Smoke",
    "category": "2 cm Bahçe Karoları",
    "sku": "stark-smoke-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCS810X0AMABF40-1.jpg"
    ],
    "description": "Stark Smoke — Tüm Karolar. 60X120 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "Dış Mekan / Bahçe / Teras",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Beton",
      "Tüm Karolar",
      "Stark Smoke",
      "2 cm Bahçe Karoları"
    ]
  },
  {
    "id": "qua-372-stark-smoke-80x80",
    "title": "Stark Smoke",
    "collection": "Stark Smoke",
    "category": "2 cm Bahçe Karoları",
    "sku": "stark-smoke-80x80",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCS810X0AMABF40-1.jpg"
    ],
    "description": "Stark Smoke — Tüm Karolar. 80X80 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "80X80 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "Dış Mekan / Bahçe / Teras",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "80X80 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "80X80 cm",
      "Beton",
      "Tüm Karolar",
      "Stark Smoke",
      "2 cm Bahçe Karoları"
    ]
  },
  {
    "id": "qua-373-stark-stone-60x60",
    "title": "Stark Stone",
    "collection": "Stark",
    "category": "2 cm Bahçe Karoları",
    "sku": "stark-stone-60x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCS810X0AMABF40-1.jpg"
    ],
    "description": "Stark Stone — Tüm Karolar. 60X60 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "Dış Mekan / Bahçe / Teras",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Beton",
      "Tüm Karolar",
      "Stark",
      "2 cm Bahçe Karoları"
    ]
  },
  {
    "id": "qua-374-stark-taupe-60X60",
    "title": "Stark Taupe",
    "collection": "Stark Taupe",
    "category": "2 cm Bahçe Karoları",
    "sku": "stark-taupe-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCS810X0AMABF40-1.jpg"
    ],
    "description": "Stark Taupe — Tüm Karolar. 60X60 ebatında beton görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "Dış Mekan / Bahçe / Teras",
      "Kalınlık": "0,9 cm",
      "Doku": "Beton",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Beton görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Beton",
      "Tüm Karolar",
      "Stark Taupe",
      "2 cm Bahçe Karoları"
    ]
  },
  {
    "id": "qua-375-statuario-60X60",
    "title": "Statuario",
    "collection": "Statuario",
    "category": "Mutfak Karoları",
    "sku": "statuario-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015ZDRS840X0XFABD10-1.jpg"
    ],
    "description": "Statuario — Mutfak Karoları. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Statuario"
    ]
  },
  {
    "id": "qua-376-statuario-60X120",
    "title": "Statuario",
    "collection": "Statuario",
    "category": "Mutfak Karoları",
    "sku": "statuario-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015ZDRS840X0XFABD10-1.jpg"
    ],
    "description": "Statuario — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Statuario"
    ]
  },
  {
    "id": "qua-377-statuario-100x100",
    "title": "Statuario",
    "collection": "Statuario",
    "category": "Mutfak Karoları",
    "sku": "statuario-100x100",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015ZDRS840X0XFABD10-1.jpg"
    ],
    "description": "Statuario — Mutfak Karoları. 100X100 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "100X100 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "100X100 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "100X100 cm",
      "Porselen",
      "Mutfak Karoları",
      "Statuario"
    ]
  },
  {
    "id": "qua-378-street-60X60",
    "title": "Street",
    "collection": "Street",
    "category": "İç Mekan Karoları",
    "sku": "street-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRS800X0BGABG20-1.jpg"
    ],
    "description": "Street — Tüm Karolar. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Tüm Karolar",
      "Street",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-379-street-60x90",
    "title": "Street",
    "collection": "Street",
    "category": "İç Mekan Karoları",
    "sku": "street-60x90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRS800X0BGABG20-1.jpg"
    ],
    "description": "Street — Tüm Karolar. 60X90 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X90 cm",
      "Porselen",
      "Tüm Karolar",
      "Street",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-380-sun-onyx-60X120",
    "title": "Sun Onyx",
    "collection": "Sun Onyx",
    "category": "Mutfak Karoları",
    "sku": "sun-onyx-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRSD90X0XFABD10-1.jpg"
    ],
    "description": "Sun Onyx — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Sun Onyx"
    ]
  },
  {
    "id": "qua-381-taj-mahal-3d-60x120",
    "title": "Taj Mahal 3D",
    "collection": "Taj Mahal",
    "category": "Mutfak Karoları",
    "sku": "taj-mahal-3d-60x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRTA5SX0XMABW00-1.jpg"
    ],
    "description": "Taj Mahal 3D — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "3D Yüzey",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "3D Yüzey yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "3D Yüzey",
      "Taj Mahal"
    ]
  },
  {
    "id": "qua-382-tales-grey-40X120",
    "title": "Tales Grey",
    "collection": "Tales",
    "category": "Mutfak Karoları",
    "sku": "tales-grey-40X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRT670X0XPABW50-1.jpg"
    ],
    "description": "Tales Grey — Mutfak Karoları. 40X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "40X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "40X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "40X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Tales"
    ]
  },
  {
    "id": "qua-383-tales-grey-dekofon-40X120",
    "title": "Tales Grey Dekofon",
    "collection": "Tales Grey Dekofon",
    "category": "Mutfak Karoları",
    "sku": "tales-grey-dekofon-40X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRT670X0XPABW50-1.jpg"
    ],
    "description": "Tales Grey Dekofon — Mutfak Karoları. 40X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "40X120 cm",
      "Yüzey": "3D Yüzey",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "40X120 cm ebat",
      "3D Yüzey yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "40X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "3D Yüzey",
      "Tales Grey Dekofon"
    ]
  },
  {
    "id": "qua-384-tales-white-60X60",
    "title": "Tales White",
    "collection": "Tales",
    "category": "Mutfak Karoları",
    "sku": "tales-white-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRT670X0XPABW50-1.jpg"
    ],
    "description": "Tales White — Mutfak Karoları. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Tales"
    ]
  },
  {
    "id": "qua-385-tales-white-61x61",
    "title": "Tales White",
    "collection": "Tales",
    "category": "Mutfak Karoları",
    "sku": "tales-white-61x61",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRT670X0XPABW50-1.jpg"
    ],
    "description": "Tales White — Mutfak Karoları. 61X61 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "61X61 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "61X61 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "61X61 cm",
      "Porselen",
      "Mutfak Karoları",
      "Tales"
    ]
  },
  {
    "id": "qua-386-tales-white-40X120",
    "title": "Tales White",
    "collection": "Tales",
    "category": "Mutfak Karoları",
    "sku": "tales-white-40X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRT670X0XPABW50-1.jpg"
    ],
    "description": "Tales White — Mutfak Karoları. 40X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "40X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "40X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "40X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Tales"
    ]
  },
  {
    "id": "qua-387-terrazzo-anthracite-197x197",
    "title": "Terrazzo Anthracite",
    "collection": "Terrazzo",
    "category": "Mutfak Karoları",
    "sku": "terrazzo-anthracite-197x197",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRT370X0BMABL00-1.jpg"
    ],
    "description": "Terrazzo Anthracite — Mutfak Karoları. 19 ebatında taş görünümlü porselen karo.",
    "specs": {
      "Ebat": "19 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Taş",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Taş görünümlü porselen kaplama",
      "19 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "19 cm",
      "Taş",
      "Mutfak Karoları",
      "Terrazzo"
    ]
  },
  {
    "id": "qua-388-terrazzo-anthracite-30x40",
    "title": "Terrazzo Anthracite",
    "collection": "Terrazzo",
    "category": "Mutfak Karoları",
    "sku": "terrazzo-anthracite-30x40",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRT370X0BMABL00-1.jpg"
    ],
    "description": "Terrazzo Anthracite — Mutfak Karoları. 30X40 ebatında taş görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X40 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Taş",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Taş görünümlü porselen kaplama",
      "30X40 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X40 cm",
      "Taş",
      "Mutfak Karoları",
      "Terrazzo"
    ]
  },
  {
    "id": "qua-389-terrazzo-anthracite-20x40",
    "title": "Terrazzo Anthracite",
    "collection": "Terrazzo",
    "category": "Mutfak Karoları",
    "sku": "terrazzo-anthracite-20x40",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRT370X0BMABL00-1.jpg"
    ],
    "description": "Terrazzo Anthracite — Mutfak Karoları. 20X40 ebatında taş görünümlü porselen karo.",
    "specs": {
      "Ebat": "20X40 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Taş",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Taş görünümlü porselen kaplama",
      "20X40 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "20X40 cm",
      "Taş",
      "Mutfak Karoları",
      "Terrazzo"
    ]
  },
  {
    "id": "qua-390-terrazzo-cream-60X60",
    "title": "Terrazzo Cream",
    "collection": "Terrazzo Cream",
    "category": "2 cm Bahçe Karoları",
    "sku": "terrazzo-cream-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRT370X0BMABL00-1.jpg"
    ],
    "description": "Terrazzo Cream — Tüm Karolar. 60X60 ebatında taş görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "Dış Mekan / Bahçe / Teras",
      "Kalınlık": "0,9 cm",
      "Doku": "Taş",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Taş görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Taş",
      "Tüm Karolar",
      "Terrazzo Cream",
      "2 cm Bahçe Karoları"
    ]
  },
  {
    "id": "qua-391-terrazzo-cream-60X120",
    "title": "Terrazzo Cream",
    "collection": "Terrazzo Cream",
    "category": "2 cm Bahçe Karoları",
    "sku": "terrazzo-cream-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRT370X0BMABL00-1.jpg"
    ],
    "description": "Terrazzo Cream — Tüm Karolar. 60X120 ebatında taş görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "Dış Mekan / Bahçe / Teras",
      "Kalınlık": "0,9 cm",
      "Doku": "Taş",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Taş görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Taş",
      "Tüm Karolar",
      "Terrazzo Cream",
      "2 cm Bahçe Karoları"
    ]
  },
  {
    "id": "qua-392-terrazzo-grey-197x197",
    "title": "Terrazzo Grey",
    "collection": "Terrazzo",
    "category": "Mutfak Karoları",
    "sku": "terrazzo-grey-197x197",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRT370X0BMABL00-1.jpg"
    ],
    "description": "Terrazzo Grey — Mutfak Karoları. 19 ebatında taş görünümlü porselen karo.",
    "specs": {
      "Ebat": "19 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Taş",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Taş görünümlü porselen kaplama",
      "19 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "19 cm",
      "Taş",
      "Mutfak Karoları",
      "Terrazzo"
    ]
  },
  {
    "id": "qua-393-terrazzo-grey-30x40",
    "title": "Terrazzo Grey",
    "collection": "Terrazzo",
    "category": "Mutfak Karoları",
    "sku": "terrazzo-grey-30x40",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRT370X0BMABL00-1.jpg"
    ],
    "description": "Terrazzo Grey — Mutfak Karoları. 30X40 ebatında taş görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X40 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Taş",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Taş görünümlü porselen kaplama",
      "30X40 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X40 cm",
      "Taş",
      "Mutfak Karoları",
      "Terrazzo"
    ]
  },
  {
    "id": "qua-394-terrazzo-grey-20x40",
    "title": "Terrazzo Grey",
    "collection": "Terrazzo",
    "category": "Mutfak Karoları",
    "sku": "terrazzo-grey-20x40",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRT370X0BMABL00-1.jpg"
    ],
    "description": "Terrazzo Grey — Mutfak Karoları. 20X40 ebatında taş görünümlü porselen karo.",
    "specs": {
      "Ebat": "20X40 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Taş",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Taş görünümlü porselen kaplama",
      "20X40 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "20X40 cm",
      "Taş",
      "Mutfak Karoları",
      "Terrazzo"
    ]
  },
  {
    "id": "qua-395-terrazzo-grigio-60X60",
    "title": "Terrazzo Grigio",
    "collection": "Terrazzo",
    "category": "2 cm Bahçe Karoları",
    "sku": "terrazzo-grigio-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRT370X0BMABL00-1.jpg"
    ],
    "description": "Terrazzo Grigio — Tüm Karolar. 60X60 ebatında taş görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "Dış Mekan / Bahçe / Teras",
      "Kalınlık": "0,9 cm",
      "Doku": "Taş",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Taş görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Taş",
      "Tüm Karolar",
      "Terrazzo",
      "2 cm Bahçe Karoları"
    ]
  },
  {
    "id": "qua-396-terrazzo-grigio-60X120",
    "title": "Terrazzo Grigio",
    "collection": "Terrazzo",
    "category": "2 cm Bahçe Karoları",
    "sku": "terrazzo-grigio-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRT370X0BMABL00-1.jpg"
    ],
    "description": "Terrazzo Grigio — Tüm Karolar. 60X120 ebatında taş görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "Dış Mekan / Bahçe / Teras",
      "Kalınlık": "0,9 cm",
      "Doku": "Taş",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Taş görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Taş",
      "Tüm Karolar",
      "Terrazzo",
      "2 cm Bahçe Karoları"
    ]
  },
  {
    "id": "qua-397-terrazzo-light-60X60",
    "title": "Terrazzo Light",
    "collection": "Terrazzo",
    "category": "2 cm Bahçe Karoları",
    "sku": "terrazzo-light-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRT370X0BMABL00-1.jpg"
    ],
    "description": "Terrazzo Light — Tüm Karolar. 60X60 ebatında taş görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "Dış Mekan / Bahçe / Teras",
      "Kalınlık": "0,9 cm",
      "Doku": "Taş",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Taş görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Taş",
      "Tüm Karolar",
      "Terrazzo",
      "2 cm Bahçe Karoları"
    ]
  },
  {
    "id": "qua-398-terrazzo-white-197x197",
    "title": "Terrazzo White",
    "collection": "Terrazzo",
    "category": "Mutfak Karoları",
    "sku": "terrazzo-white-197x197",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRT370X0BMABL00-1.jpg"
    ],
    "description": "Terrazzo White — Mutfak Karoları. 19 ebatında taş görünümlü porselen karo.",
    "specs": {
      "Ebat": "19 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Taş",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Taş görünümlü porselen kaplama",
      "19 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "19 cm",
      "Taş",
      "Mutfak Karoları",
      "Terrazzo"
    ]
  },
  {
    "id": "qua-399-terrazzo-white-30x40",
    "title": "Terrazzo White",
    "collection": "Terrazzo",
    "category": "Mutfak Karoları",
    "sku": "terrazzo-white-30x40",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRT370X0BMABL00-1.jpg"
    ],
    "description": "Terrazzo White — Mutfak Karoları. 30X40 ebatında taş görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X40 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Taş",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Taş görünümlü porselen kaplama",
      "30X40 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X40 cm",
      "Taş",
      "Mutfak Karoları",
      "Terrazzo"
    ]
  },
  {
    "id": "qua-400-terrazzo-white-20x40",
    "title": "Terrazzo White",
    "collection": "Terrazzo",
    "category": "Mutfak Karoları",
    "sku": "terrazzo-white-20x40",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015BDRT370X0BMABL00-1.jpg"
    ],
    "description": "Terrazzo White — Mutfak Karoları. 20X40 ebatında taş görünümlü porselen karo.",
    "specs": {
      "Ebat": "20X40 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Taş",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Taş görünümlü porselen kaplama",
      "20X40 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "20X40 cm",
      "Taş",
      "Mutfak Karoları",
      "Terrazzo"
    ]
  },
  {
    "id": "qua-401-tiber-wood-ash-30x120",
    "title": "Tiber Wood Ash",
    "collection": "Tiber Wood Ash",
    "category": "İç Mekan Karoları",
    "sku": "tiber-wood-ash-30x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P171BDCT540X0XMABG10-1.jpg"
    ],
    "description": "Tiber Wood Ash — Tüm Karolar. 30X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X120 cm",
      "Porselen",
      "Tüm Karolar",
      "Tiber Wood Ash",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-402-tiber-wood-avana-30x120",
    "title": "Tiber Wood Avana",
    "collection": "Tiber Wood Avana",
    "category": "İç Mekan Karoları",
    "sku": "tiber-wood-avana-30x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P171BDCT540X0XMABG10-1.jpg"
    ],
    "description": "Tiber Wood Avana — Tüm Karolar. 30X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X120 cm",
      "Porselen",
      "Tüm Karolar",
      "Tiber Wood Avana",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-403-tiber-wood-grigio-30x120",
    "title": "Tiber Wood Grigio",
    "collection": "Tiber Wood",
    "category": "İç Mekan Karoları",
    "sku": "tiber-wood-grigio-30x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P171BDCT540X0XMABG10-1.jpg"
    ],
    "description": "Tiber Wood Grigio — Tüm Karolar. 30X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X120 cm",
      "Porselen",
      "Tüm Karolar",
      "Tiber Wood",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-404-tiber-wood-natural-30x120",
    "title": "Tiber Wood Natural",
    "collection": "Tiber Wood",
    "category": "İç Mekan Karoları",
    "sku": "tiber-wood-natural-30x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P171BDCT540X0XMABG10-1.jpg"
    ],
    "description": "Tiber Wood Natural — Tüm Karolar. 30X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "30X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X120 cm",
      "Porselen",
      "Tüm Karolar",
      "Tiber Wood",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-405-tivoli-beige-3d-60x120",
    "title": "Tivoli Beige 3D",
    "collection": "Tivoli Beige",
    "category": "Mutfak Karoları",
    "sku": "tivoli-beige-3d-60x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRTA4SX0XMABBO0-1.jpg"
    ],
    "description": "Tivoli Beige 3D — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "3D Yüzey",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "3D Yüzey yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "3D Yüzey",
      "Tivoli Beige"
    ]
  },
  {
    "id": "qua-406-tivoli-bone-3d-60x120",
    "title": "Tivoli Bone 3D",
    "collection": "Tivoli Bone",
    "category": "Mutfak Karoları",
    "sku": "tivoli-bone-3d-60x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRTA4SX0XMABBO0-1.jpg"
    ],
    "description": "Tivoli Bone 3D — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "3D Yüzey",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "3D Yüzey yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "3D Yüzey",
      "Tivoli Bone"
    ]
  },
  {
    "id": "qua-407-tiziana-60X60",
    "title": "Tiziana",
    "collection": "Tiziana",
    "category": "İç Mekan Karoları",
    "sku": "tiziana-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015ZDRT760X0XMABD10-1.jpg"
    ],
    "description": "Tiziana — Tüm Karolar. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Tüm Karolar",
      "Tiziana",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-408-travertine-beige-30x60",
    "title": "Travertine Beige",
    "collection": "Travertine",
    "category": "Mutfak Karoları",
    "sku": "travertine-beige-30x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCT360X0XMABBO0-1.jpg"
    ],
    "description": "Travertine Beige — Mutfak Karoları. 30X60 ebatında travertin görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Travertin",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Travertin görünümlü porselen kaplama",
      "30X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X60 cm",
      "Travertin",
      "Mutfak Karoları",
      "Travertine"
    ]
  },
  {
    "id": "qua-409-travertine-beige-60X60",
    "title": "Travertine Beige",
    "collection": "Travertine",
    "category": "İç Mekan Karoları",
    "sku": "travertine-beige-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCT360X0XMABBO0-1.jpg"
    ],
    "description": "Travertine Beige — Tüm Karolar. 60X60 ebatında travertin görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Travertin",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Travertin görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Travertin",
      "Tüm Karolar",
      "Travertine",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-410-travertine-beige-60x90",
    "title": "Travertine Beige",
    "collection": "Travertine",
    "category": "İç Mekan Karoları",
    "sku": "travertine-beige-60x90",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCT360X0XMABBO0-1.jpg"
    ],
    "description": "Travertine Beige — Tüm Karolar. 60X90 ebatında travertin görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X90 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Yer ve Duvar",
      "Kalınlık": "0,9 cm",
      "Doku": "Travertin",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Travertin görünümlü porselen kaplama",
      "60X90 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X90 cm",
      "Travertin",
      "Tüm Karolar",
      "Travertine",
      "İç Mekan Karoları"
    ]
  },
  {
    "id": "qua-411-travertine-silver-30x60",
    "title": "Travertine Silver",
    "collection": "Travertine",
    "category": "Mutfak Karoları",
    "sku": "travertine-silver-30x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCT360X0XMABBO0-1.jpg"
    ],
    "description": "Travertine Silver — Mutfak Karoları. 30X60 ebatında travertin görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Travertin",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Travertin görünümlü porselen kaplama",
      "30X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X60 cm",
      "Travertin",
      "Mutfak Karoları",
      "Travertine"
    ]
  },
  {
    "id": "qua-412-travertine-white-30x60",
    "title": "Travertine White",
    "collection": "Travertine",
    "category": "Mutfak Karoları",
    "sku": "travertine-white-30x60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P010ZDCT360X0XMABBO0-1.jpg"
    ],
    "description": "Travertine White — Mutfak Karoları. 30X60 ebatında travertin görünümlü porselen karo.",
    "specs": {
      "Ebat": "30X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Travertin",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Travertin görünümlü porselen kaplama",
      "30X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "30X60 cm",
      "Travertin",
      "Mutfak Karoları",
      "Travertine"
    ]
  },
  {
    "id": "qua-413-trend-wood-greige-20x120",
    "title": "Trend Wood Greige",
    "collection": "Trend Wood Greige",
    "category": "Mutfak Karoları",
    "sku": "trend-wood-greige-20x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P192ZDRT550V0XMABGR0-1.jpg"
    ],
    "description": "Trend Wood Greige — Mutfak Karoları. 20X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "20X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "20X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "20X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Trend Wood Greige"
    ]
  },
  {
    "id": "qua-414-trend-wood-natural-20x120",
    "title": "Trend Wood Natural",
    "collection": "Trend Wood",
    "category": "Mutfak Karoları",
    "sku": "trend-wood-natural-20x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P192ZDRT550V0XMABGR0-1.jpg"
    ],
    "description": "Trend Wood Natural — Mutfak Karoları. 20X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "20X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "20X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "20X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Trend Wood"
    ]
  },
  {
    "id": "qua-415-trend-wood-oak-20x120",
    "title": "Trend Wood Oak",
    "collection": "Trend Wood",
    "category": "Mutfak Karoları",
    "sku": "trend-wood-oak-20x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P192ZDRT550V0XMABGR0-1.jpg"
    ],
    "description": "Trend Wood Oak — Mutfak Karoları. 20X120 ebatında ahşap görünümlü porselen karo.",
    "specs": {
      "Ebat": "20X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Ahşap",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Ahşap görünümlü porselen kaplama",
      "20X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "20X120 cm",
      "Ahşap",
      "Mutfak Karoları",
      "Trend Wood"
    ]
  },
  {
    "id": "qua-416-valery-clair-60X60",
    "title": "Valery Clair",
    "collection": "Valery Clair",
    "category": "Mutfak Karoları",
    "sku": "valery-clair-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRV530X0XMABG40-1.jpg"
    ],
    "description": "Valery Clair — Mutfak Karoları. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Valery Clair"
    ]
  },
  {
    "id": "qua-417-valery-clair-gris-60X60",
    "title": "Valery Clair Gris",
    "collection": "Valery Clair Gris",
    "category": "Mutfak Karoları",
    "sku": "valery-clair-gris-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRV530X0XMABG40-1.jpg"
    ],
    "description": "Valery Clair Gris — Mutfak Karoları. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Valery Clair Gris"
    ]
  },
  {
    "id": "qua-418-valery-vison-60X60",
    "title": "Valery Vison",
    "collection": "Valery Vison",
    "category": "Mutfak Karoları",
    "sku": "valery-vison-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/F015ZDRV530X0XMABG40-1.jpg"
    ],
    "description": "Valery Vison — Mutfak Karoları. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Valery Vison"
    ]
  },
  {
    "id": "qua-419-vanya-60X120",
    "title": "Vanya",
    "collection": "Vanya",
    "category": "Mutfak Karoları",
    "sku": "vanya-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P156ZDRV490X0XFABD10-1.jpg"
    ],
    "description": "Vanya — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Vanya"
    ]
  },
  {
    "id": "qua-420-venato-onice-beige-60X60",
    "title": "Venato Onice Beige",
    "collection": "Venato Onice",
    "category": "Mutfak Karoları",
    "sku": "venato-onice-beige-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015ZDRV510X0XFABBO0-1.jpg"
    ],
    "description": "Venato Onice Beige — Mutfak Karoları. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Venato Onice"
    ]
  },
  {
    "id": "qua-421-venato-onice-beige-60X120",
    "title": "Venato Onice Beige",
    "collection": "Venato Onice",
    "category": "Mutfak Karoları",
    "sku": "venato-onice-beige-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015ZDRV510X0XFABBO0-1.jpg"
    ],
    "description": "Venato Onice Beige — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Venato Onice"
    ]
  },
  {
    "id": "qua-422-venato-onice-gris-60X60",
    "title": "Venato Onice Gris",
    "collection": "Venato Onice Gris",
    "category": "Mutfak Karoları",
    "sku": "venato-onice-gris-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015ZDRV510X0XFABBO0-1.jpg"
    ],
    "description": "Venato Onice Gris — Mutfak Karoları. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Venato Onice Gris"
    ]
  },
  {
    "id": "qua-423-venato-onice-gris-60X120",
    "title": "Venato Onice Gris",
    "collection": "Venato Onice Gris",
    "category": "Mutfak Karoları",
    "sku": "venato-onice-gris-60X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015ZDRV510X0XFABBO0-1.jpg"
    ],
    "description": "Venato Onice Gris — Mutfak Karoları. 60X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Venato Onice Gris"
    ]
  },
  {
    "id": "qua-424-venecia-gold-100x100",
    "title": "Venecia Gold",
    "collection": "Venecia Gold",
    "category": "Mutfak Karoları",
    "sku": "venecia-gold-100x100",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P198XDRV590X0XFAB140-1.jpg"
    ],
    "description": "Venecia Gold — Mutfak Karoları. 100X100 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "100X100 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "100X100 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "100X100 cm",
      "Porselen",
      "Mutfak Karoları",
      "Venecia Gold"
    ]
  },
  {
    "id": "qua-425-venecia-grey-100x100",
    "title": "Venecia Grey",
    "collection": "Venecia",
    "category": "Mutfak Karoları",
    "sku": "venecia-grey-100x100",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P198XDRV590X0XFAB140-1.jpg"
    ],
    "description": "Venecia Grey — Mutfak Karoları. 100X100 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "100X100 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "100X100 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "100X100 cm",
      "Porselen",
      "Mutfak Karoları",
      "Venecia"
    ]
  },
  {
    "id": "qua-426-vivaldi-40X120",
    "title": "Vivaldi",
    "collection": "Vivaldi",
    "category": "Mutfak Karoları",
    "sku": "vivaldi-40X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015ZDRV440X0XMABD10-1.jpg"
    ],
    "description": "Vivaldi — Mutfak Karoları. 40X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "40X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "40X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "40X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Vivaldi"
    ]
  },
  {
    "id": "qua-427-vivaldi-61x61",
    "title": "Vivaldi",
    "collection": "Vivaldi",
    "category": "Mutfak Karoları",
    "sku": "vivaldi-61x61",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015ZDRV440X0XMABD10-1.jpg"
    ],
    "description": "Vivaldi — Mutfak Karoları. 61X61 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "61X61 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "61X61 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "61X61 cm",
      "Porselen",
      "Mutfak Karoları",
      "Vivaldi"
    ]
  },
  {
    "id": "qua-428-vivaldi-60X60",
    "title": "Vivaldi",
    "collection": "Vivaldi",
    "category": "Mutfak Karoları",
    "sku": "vivaldi-60X60",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015ZDRV440X0XMABD10-1.jpg"
    ],
    "description": "Vivaldi — Mutfak Karoları. 60X60 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "60X60 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "60X60 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "60X60 cm",
      "Porselen",
      "Mutfak Karoları",
      "Vivaldi"
    ]
  },
  {
    "id": "qua-429-vivaldi-white-dekofon-40X120",
    "title": "Vivaldi White Dekofon",
    "collection": "Vivaldi White Dekofon",
    "category": "Mutfak Karoları",
    "sku": "vivaldi-white-dekofon-40X120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P015ZDRV440X0XMABD10-1.jpg"
    ],
    "description": "Vivaldi White Dekofon — Mutfak Karoları. 40X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "40X120 cm",
      "Yüzey": "3D Yüzey",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "40X120 cm ebat",
      "3D Yüzey yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "40X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "3D Yüzey",
      "Vivaldi White Dekofon"
    ]
  },
  {
    "id": "qua-430-western-20x120",
    "title": "Western",
    "collection": "Western",
    "category": "Mutfak Karoları",
    "sku": "western-20x120",
    "images": [
      "https://quagranite.b-cdn.net/uploads/P192ZDRW160X0XMABS50-1.jpg"
    ],
    "description": "Western — Mutfak Karoları. 20X120 ebatında porselen görünümlü porselen karo.",
    "specs": {
      "Ebat": "20X120 cm",
      "Yüzey": "Mat",
      "Kullanım Alanı": "İç Mekan / Mutfak / Banyo",
      "Kalınlık": "0,9 cm",
      "Doku": "Porselen",
      "Ürün Tipi": "Sırlı Porselen"
    },
    "features": [
      "Porselen görünümlü porselen kaplama",
      "20X120 cm ebat",
      "Mat yüzey işlemi",
      "İç mekan kullanımına uygun",
      "Rektifiyeli kenar işlemi",
      "ISO 13006 standardına uygun"
    ],
    "tags": [
      "20X120 cm",
      "Porselen",
      "Mutfak Karoları",
      "Western"
    ]
  }
]